const basicLightbox = {
  _toElement: function (e, t = !1) {
    const n = document.createElement("div");
    return (n.innerHTML = e.trim()), !0 === t ? n.children : n.firstChild;
  },
  _validateOptions: function (e = {}) {
    return (
      null == (e = Object.assign({}, e)).closable && (e.closable = !0),
      null == e.className && (e.className = ""),
      null == e.onShow && (e.onShow = () => {}),
      null == e.onClose && (e.onClose = () => {}),
      null == e.trigger && (e.trigger = !1),
      null == e.focus && (e.focus = !1),
      e
    );
  },
  _validateContent: function (e) {
    const t = "string" == typeof e,
      n = e instanceof HTMLElement == !0;
    if (!1 === t && !1 === n)
      throw new Error("Content must be a DOM element/node or string");
    return !0 === t
      ? Array.from(this._toElement(e, !0))
      : "TEMPLATE" === e.tagName
      ? [e.content.cloneNode(!0)]
      : Array.from(e.children);
  },
  _containsTag: function (e, t) {
    const n = e.children;
    return 1 === n.length && n[0].tagName === t;
  },
  _render: function (e, t) {
    const n = this._toElement(
        `\n      <div class="basicLightbox ${t.className}">\n        <div class="basicLightbox__placeholder" role="dialog"></div>\n      </div>\n    `
      ),
      i = n.querySelector(".basicLightbox__placeholder");
    e.forEach((e) => i.appendChild(e));
    const o = this._containsTag(i, "IMG"),
      s = this._containsTag(i, "VIDEO"),
      l = this._containsTag(i, "IFRAME");
    return (
      !0 === o && n.classList.add("basicLightbox--img"),
      !0 === s && n.classList.add("basicLightbox--video"),
      !0 === l && n.classList.add("basicLightbox--iframe"),
      n
    );
  },
  _show: function (e, t) {
    return (
      document.body.appendChild(e),
      setTimeout(() => {
        requestAnimationFrame(
          () => (e.classList.add("basicLightbox--visible"), t())
        );
      }, 10),
      !0
    );
  },
  _close: function (e, t) {
    return (
      e.classList.remove("basicLightbox--visible"),
      setTimeout(
        () => (!1 === this._visible(e) || e.parentElement.removeChild(e), t()),
        410
      ),
      !0
    );
  },
  _visible: function (e) {
    return (
      null != (e = e || document.querySelector(".basicLightbox")) &&
      !0 === e.ownerDocument.body.contains(e)
    );
  },
  create: function (e, t) {
    (e = this._validateContent(e)), (t = this._validateOptions(t));
    const n = this._render(e, t),
      i = (e, i) =>
        !1 !== t.onShow(s) &&
        this._show(n, () => {
          if (
            ("string" == typeof i &&
              n.querySelectorAll(i) &&
              n.querySelectorAll(i)[0].focus(),
            "function" == typeof e)
          )
            return e(s);
        }),
      o = (e) =>
        !1 !== t.onClose(s) &&
        this._close(n, () => {
          if ("function" == typeof e) return e(s);
        });
    !0 === t.closable &&
      (n.addEventListener("click", (e) => {
        e.target === n && o();
      }),
      window.addEventListener("keydown", (e) => {
        27 == e.keyCode && o();
      }),
      n.querySelector(".basicLightboxClose") &&
        (n
          .querySelector(".basicLightboxClose")
          .addEventListener("click", (e) => {
            e.preventDefault(), o();
          }),
        n
          .querySelector(".basicLightboxClose")
          .addEventListener("keydown", (e) => {
            13 == e.keyCode && o();
          }))),
      t.trigger &&
        (t.trigger.addEventListener("click", (e) => {
          e.preventDefault(), i(null, t.focus);
        }),
        t.trigger.addEventListener("keydown", (e) => {
          13 == e.keyCode && i(null, t.focus);
        }));
    const s = {
      element: () => n,
      visible: () => this._visible(n),
      show: i,
      close: o,
    };
    return s;
  },
};
!(function () {
  "use strict";
  function o() {
    var o = window,
      t = document;
    if (
      !("scrollBehavior" in t.documentElement.style) ||
      !0 === o.__forceSmoothScrollPolyfill__
    ) {
      var l,
        e = o.HTMLElement || o.Element,
        r = 468,
        i = {
          scroll: o.scroll || o.scrollTo,
          scrollBy: o.scrollBy,
          elementScroll: e.prototype.scroll || n,
          scrollIntoView: e.prototype.scrollIntoView,
        },
        s =
          o.performance && o.performance.now
            ? o.performance.now.bind(o.performance)
            : Date.now,
        c =
          ((l = o.navigator.userAgent),
          new RegExp(["MSIE ", "Trident/", "Edge/"].join("|")).test(l) ? 1 : 0);
      (o.scroll = o.scrollTo =
        function () {
          void 0 !== arguments[0] &&
            (!0 !== f(arguments[0])
              ? h.call(
                  o,
                  t.body,
                  void 0 !== arguments[0].left
                    ? ~~arguments[0].left
                    : o.scrollX || o.pageXOffset,
                  void 0 !== arguments[0].top
                    ? ~~arguments[0].top
                    : o.scrollY || o.pageYOffset
                )
              : i.scroll.call(
                  o,
                  void 0 !== arguments[0].left
                    ? arguments[0].left
                    : "object" != typeof arguments[0]
                    ? arguments[0]
                    : o.scrollX || o.pageXOffset,
                  void 0 !== arguments[0].top
                    ? arguments[0].top
                    : void 0 !== arguments[1]
                    ? arguments[1]
                    : o.scrollY || o.pageYOffset
                ));
        }),
        (o.scrollBy = function () {
          void 0 !== arguments[0] &&
            (f(arguments[0])
              ? i.scrollBy.call(
                  o,
                  void 0 !== arguments[0].left
                    ? arguments[0].left
                    : "object" != typeof arguments[0]
                    ? arguments[0]
                    : 0,
                  void 0 !== arguments[0].top
                    ? arguments[0].top
                    : void 0 !== arguments[1]
                    ? arguments[1]
                    : 0
                )
              : h.call(
                  o,
                  t.body,
                  ~~arguments[0].left + (o.scrollX || o.pageXOffset),
                  ~~arguments[0].top + (o.scrollY || o.pageYOffset)
                ));
        }),
        (e.prototype.scroll = e.prototype.scrollTo =
          function () {
            if (void 0 !== arguments[0])
              if (!0 !== f(arguments[0])) {
                var o = arguments[0].left,
                  t = arguments[0].top;
                h.call(
                  this,
                  this,
                  void 0 === o ? this.scrollLeft : ~~o,
                  void 0 === t ? this.scrollTop : ~~t
                );
              } else {
                if ("number" == typeof arguments[0] && void 0 === arguments[1])
                  throw new SyntaxError("Value could not be converted");
                i.elementScroll.call(
                  this,
                  void 0 !== arguments[0].left
                    ? ~~arguments[0].left
                    : "object" != typeof arguments[0]
                    ? ~~arguments[0]
                    : this.scrollLeft,
                  void 0 !== arguments[0].top
                    ? ~~arguments[0].top
                    : void 0 !== arguments[1]
                    ? ~~arguments[1]
                    : this.scrollTop
                );
              }
          }),
        (e.prototype.scrollBy = function () {
          void 0 !== arguments[0] &&
            (!0 !== f(arguments[0])
              ? this.scroll({
                  left: ~~arguments[0].left + this.scrollLeft,
                  top: ~~arguments[0].top + this.scrollTop,
                  behavior: arguments[0].behavior,
                })
              : i.elementScroll.call(
                  this,
                  void 0 !== arguments[0].left
                    ? ~~arguments[0].left + this.scrollLeft
                    : ~~arguments[0] + this.scrollLeft,
                  void 0 !== arguments[0].top
                    ? ~~arguments[0].top + this.scrollTop
                    : ~~arguments[1] + this.scrollTop
                ));
        }),
        (e.prototype.scrollIntoView = function () {
          if (!0 !== f(arguments[0])) {
            var l = (function (o) {
                for (
                  ;
                  o !== t.body &&
                  !1 ===
                    ((e = p((l = o), "Y") && a(l, "Y")),
                    (r = p(l, "X") && a(l, "X")),
                    e || r);

                )
                  o = o.parentNode || o.host;
                var l, e, r;
                return o;
              })(this),
              e = l.getBoundingClientRect(),
              r = this.getBoundingClientRect();
            l !== t.body
              ? (h.call(
                  this,
                  l,
                  l.scrollLeft + r.left - e.left,
                  l.scrollTop + r.top - e.top
                ),
                "fixed" !== o.getComputedStyle(l).position &&
                  o.scrollBy({ left: e.left, top: e.top, behavior: "smooth" }))
              : o.scrollBy({ left: r.left, top: r.top, behavior: "smooth" });
          } else
            i.scrollIntoView.call(
              this,
              void 0 === arguments[0] || arguments[0]
            );
        });
    }
    function n(o, t) {
      (this.scrollLeft = o), (this.scrollTop = t);
    }
    function f(o) {
      if (
        null === o ||
        "object" != typeof o ||
        void 0 === o.behavior ||
        "auto" === o.behavior ||
        "instant" === o.behavior
      )
        return !0;
      if ("object" == typeof o && "smooth" === o.behavior) return !1;
      throw new TypeError(
        "behavior member of ScrollOptions " +
          o.behavior +
          " is not a valid value for enumeration ScrollBehavior."
      );
    }
    function p(o, t) {
      return "Y" === t
        ? o.clientHeight + c < o.scrollHeight
        : "X" === t
        ? o.clientWidth + c < o.scrollWidth
        : void 0;
    }
    function a(t, l) {
      var e = o.getComputedStyle(t, null)["overflow" + l];
      return "auto" === e || "scroll" === e;
    }
    function d(t) {
      var l,
        e,
        i,
        c,
        n = (s() - t.startTime) / r;
      (c = n = n > 1 ? 1 : n),
        (l = 0.5 * (1 - Math.cos(Math.PI * c))),
        (e = t.startX + (t.x - t.startX) * l),
        (i = t.startY + (t.y - t.startY) * l),
        t.method.call(t.scrollable, e, i),
        (e === t.x && i === t.y) || o.requestAnimationFrame(d.bind(o, t));
    }
    function h(l, e, r) {
      var c,
        f,
        p,
        a,
        h = s();
      l === t.body
        ? ((c = o),
          (f = o.scrollX || o.pageXOffset),
          (p = o.scrollY || o.pageYOffset),
          (a = i.scroll))
        : ((c = l), (f = l.scrollLeft), (p = l.scrollTop), (a = n)),
        d({
          scrollable: c,
          method: a,
          startTime: h,
          startX: f,
          startY: p,
          x: e,
          y: r,
        });
    }
  }
  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = { polyfill: o })
    : o();
})();
class AnnouncementBar extends HTMLElement {
  constructor() {
    super(),
      document.querySelector(".announcement__exit") &&
        document
          .querySelector(".announcement__exit")
          .addEventListener("click", () => {
            document.body.classList.add("no-transition"),
              setTimeout(() => {
                document.body.classList.remove("show-announcement-bar"),
                  localStorage.setItem("announcement-dismissed", "true"),
                  setTimeout(() => {
                    document.body.classList.remove("no-transitions");
                  }, 100);
              }, 10);
          });
  }
}
customElements.define("announcement-bar", AnnouncementBar);
const toggleAnnouncement = (e) => {
  e.target.classList.contains("mount-announcement") &&
    (document.querySelector(".announcement")
      ? document.body.classList.add("show-announcement-bar")
      : document.body.classList.remove("show-announcement-bar"));
};
document.addEventListener("shopify:section:load", toggleAnnouncement),
  document.addEventListener("shopify:section:select", toggleAnnouncement);
class CartForm extends HTMLElement {
  constructor() {
    super(), this.ajaxifyCartItems();
  }
  ajaxifyCartItems() {
    (this.form = this.querySelector("form")),
      this.querySelectorAll(".cart-item").forEach((t) => {
        const e = t.querySelector(".remove");
        e &&
          ((e.dataset.href = e.getAttribute("href")),
          e.setAttribute("href", ""),
          e.addEventListener("click", (e) => {
            e.preventDefault(), this.updateCartQty(t, 0);
          }));
        const r = t.querySelector(".qty");
        r &&
          (r.addEventListener(
            "input",
            debounce((e) => {
              e.preventDefault(),
                e.target.blur(),
                this.updateCartQty(t, parseInt(r.value));
            }, 300)
          ),
          r.addEventListener("click", (t) => {
            t.target.select();
          }));
      });
  }
  updateCartQty(t, e) {
    this.form.classList.add("processing"),
      this.querySelector(".alert") && this.querySelector(".alert").remove();
    const r = JSON.stringify({ id: t.dataset.id, quantity: e });
    fetch(KROWN.settings.routes.cart_change_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/javascript",
      },
      body: r,
    })
      .then((t) => {
        if (t.ok) return fetch("?section_id=cart-helper");
        throw new Error("Something went wrong");
      })
      .then((t) => t.text())
      .then((r) => {
        const a = new DOMParser().parseFromString(r, "text/html"),
          n = a.getElementById("AjaxCartForm").innerHTML,
          s = a.getElementById("AjaxCartSubtotal").innerHTML,
          o = document.getElementById("AjaxCartForm");
        if (
          ((o.innerHTML = n),
          o.ajaxifyCartItems(),
          (document.querySelector("[data-header-cart-count]").textContent =
            o.querySelector("[data-cart-count]").textContent),
          0 != e &&
            e >
              parseInt(
                o.querySelector(`.cart-item[data-id="${t.dataset.id}"]`).dataset
                  .qty
              ))
        ) {
          let e = document.createElement("span");
          e.classList.add("alert", "alert--error"),
            (e.textContent = KROWN.settings.locales.cart_add_error.replace(
              "{{ title }}",
              t.dataset.title
            )),
            this.form.prepend(e);
        }
        (document.getElementById("AjaxCartSubtotal").innerHTML = s),
          window.preloadImages(o);
      })
      .catch((t) => {
        console.log(t);
        let e = document.createElement("span");
        e.classList.add("alert", "alert--error"),
          (e.textContent = KROWN.settings.locales.cart_general_error),
          this.form.prepend(e);
      })
      .finally(() => {
        this.form.classList.remove("processing");
      });
  }
}
customElements.define("cart-form", CartForm);
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super(),
      (this.filterData = []),
      (this.onActiveFilterClick = this.onActiveFilterClick.bind(this)),
      (this.debouncedOnSubmit = debounce((e) => {
        this.onSubmitHandler(e);
      }, 500)),
      this.querySelector("form").addEventListener(
        "input",
        this.debouncedOnSubmit.bind(this)
      ),
      this.classList.contains("don-t-duplicate") ||
        ((document.getElementById("FacetFiltersFormMobile").innerHTML =
          document.getElementById("FacetFiltersForm").innerHTML),
        document
          .getElementById("FacetFiltersFormMobile")
          .addEventListener("input", this.debouncedOnSubmit.bind(this)),
        document
          .getElementById("FacetFiltersFormMobile")
          .querySelectorAll(".facets__item")
          .forEach((e) => {
            const t = e.querySelector("input").id;
            e.querySelector("label").setAttribute("for", "mobile-" + t),
              (e.querySelector("input").id = "mobile-" + t);
          }),
        document
          .getElementById("FacetFiltersFormMobile")
          .querySelector(".active-facets")
          .classList.remove("active-facets-desktop"),
        document
          .getElementById("FacetFiltersFormMobile")
          .querySelector(".active-facets")
          .classList.add("active-facets-mobile"));
  }
  static setListeners() {
    window.addEventListener("popstate", (e) => {
      const t = e.state
        ? e.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      t !== FacetFiltersForm.searchParamsPrev &&
        FacetFiltersForm.renderPage(t, null, !1);
    });
  }
  static toggleActiveFacets(e = !0) {
    document.querySelectorAll(".js-facet-remove").forEach((t) => {
      t.classList.toggle("disabled", e);
    });
  }
  static renderPage(e, t, r = !0) {
    FacetFiltersForm.searchParamsPrev = e;
    const i = FacetFiltersForm.getSections();
    document
      .getElementById("main-collection-product-grid")
      .classList.add("loading"),
      i.forEach((r) => {
        const i = `${window.location.pathname}?section_id=${r.section}&${e}`,
          c = (e) => e.url === i;
        FacetFiltersForm.filterData.some(c)
          ? FacetFiltersForm.renderSectionFromCache(c, t)
          : FacetFiltersForm.renderSectionFromFetch(i, t);
      }),
      r && FacetFiltersForm.updateURLHash(e);
  }
  static renderSectionFromFetch(e, t) {
    fetch(e)
      .then((e) => e.text())
      .then((r) => {
        const i = r;
        (FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html: i, url: e },
        ]),
          FacetFiltersForm.renderFilters(i, t),
          FacetFiltersForm.renderProductGrid(i),
          FacetFiltersForm.renderProductCount(i);
      });
  }
  static renderSectionFromCache(e, t) {
    const r = FacetFiltersForm.filterData.find(e).html;
    FacetFiltersForm.renderFilters(r, t),
      FacetFiltersForm.renderProductGrid(r),
      FacetFiltersForm.renderProductCount(r);
  }
  static renderProductGrid(e) {
    const t = new DOMParser()
      .parseFromString(e, "text/html")
      .getElementById("CollectionProductGrid").innerHTML;
    (document.getElementById("CollectionProductGrid").innerHTML = t),
      window.preloadImages(document.getElementById("CollectionProductGrid"));
  }
  static renderProductCount(e) {
    const t = new DOMParser()
      .parseFromString(e, "text/html")
      .getElementById("CollectionProductCount");
    t &&
      (document.getElementById("CollectionProductCount").innerHTML =
        t.innerHTML);
  }
  static renderFilters(e, t) {
    const r = new DOMParser().parseFromString(e, "text/html"),
      i = r.querySelectorAll(
        "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter"
      ),
      c = (e) => {
        if (t && t.target.closest(".js-filter"))
          return (
            e.dataset.index === t.target.closest(".js-filter").dataset.index
          );
      },
      a = Array.from(i).filter((e) => !c(e)),
      s = Array.from(i).find(c);
    a.forEach((e) => {
      document.querySelector(
        `.js-filter[data-index="${e.dataset.index}"]`
      ).innerHTML = e.innerHTML;
    }),
      FacetFiltersForm.renderActiveFacets(r),
      s && FacetFiltersForm.renderCounts(s, t.target.closest(".js-filter"));
  }
  static renderActiveFacets(e) {
    [".active-facets-mobile", ".active-facets-desktop"].forEach((t) => {
      const r = e.querySelector(".active-facets");
      r &&
        document.querySelector(t) &&
        (document.querySelector(t).innerHTML = r.innerHTML);
    }),
      FacetFiltersForm.toggleActiveFacets(!1);
  }
  static renderCounts(e, t) {
    [".facets__selected"].forEach((r) => {
      const i = t.querySelector(r);
      e.querySelector(r) &&
        i &&
        (t.querySelector(r).outerHTML = e.querySelector(r).outerHTML);
    });
  }
  static updateURLHash(e) {
    history.pushState(
      { searchParams: e },
      "",
      `${window.location.pathname}${e && "?".concat(e)}`
    );
  }
  static getSections() {
    return [
      {
        id: "main-collection-product-grid",
        section: document.getElementById("main-collection-product-grid").dataset
          .id,
      },
    ];
  }
  onSubmitHandler(e) {
    e.preventDefault();
    const t = new FormData(e.target.closest("form")),
      r = new URLSearchParams(t).toString();
    FacetFiltersForm.renderPage(r, e);
  }
  onActiveFilterClick(e) {
    e.preventDefault(),
      FacetFiltersForm.toggleActiveFacets(),
      FacetFiltersForm.renderPage(
        new URL(e.currentTarget.href).searchParams.toString()
      );
  }
}
(FacetFiltersForm.filterData = []),
  (FacetFiltersForm.searchParamsInitial = window.location.search.slice(1)),
  (FacetFiltersForm.searchParamsPrev = window.location.search.slice(1)),
  customElements.define("facet-filters-form", FacetFiltersForm),
  FacetFiltersForm.setListeners();
class FacetRemove extends HTMLElement {
  constructor() {
    super(),
      this.querySelector("a").addEventListener("click", (e) => {
        e.preventDefault();
        (
          this.closest("facet-filters-form") ||
          document.querySelector("facet-filters-form")
        ).onActiveFilterClick(e);
      });
  }
}
customElements.define("facet-remove", FacetRemove);
class PriceRange extends HTMLElement {
  constructor() {
    super(),
      this.querySelectorAll("input").forEach((e) =>
        e.addEventListener("change", this.onRangeChange.bind(this))
      ),
      this.setMinAndMaxValues();
  }
  onRangeChange(e) {
    this.adjustToValidValues(e.currentTarget), this.setMinAndMaxValues();
  }
  setMinAndMaxValues() {
    const e = this.querySelectorAll("input"),
      t = e[0],
      r = e[1];
    r.value && t.setAttribute("max", r.value),
      t.value && r.setAttribute("min", t.value),
      "" === t.value && r.setAttribute("min", 0),
      "" === r.value && t.setAttribute("max", r.getAttribute("max"));
  }
  adjustToValidValues(e) {
    const t = Number(e.value),
      r = Number(e.getAttribute("min")),
      i = Number(e.getAttribute("max"));
    t < r && (e.value = r), t > i && (e.value = i);
  }
}
customElements.define("price-range", PriceRange);
class LocalizationForm extends HTMLElement {
  constructor() {
    super(),
      (this.selector = this.querySelector(".regular-select-cover")),
      (this.content = this.querySelector(".regular-select-content")),
      this.selector.addEventListener("click", (e) => {
        e.stopPropagation(),
          e.preventDefault(),
          document
            .querySelectorAll(".regular-select-cover.content-opened")
            .forEach((t) => {
              t != e.currentTarget &&
                (t.classList.remove("content-opened"),
                (t.parentNode.style.zIndex = 9));
            }),
          this.content.classList.contains("content-opened")
            ? (e.currentTarget.setAttribute("aria-expanded", "false"),
              (this.content.parentNode.style.zIndex = 9),
              this.content.classList.remove("content-opened", "invert"),
              window.removeEventListener("click", this.onClickHandler))
            : (this.content.classList.add("content-opened"),
              e.currentTarget.setAttribute("aria-expanded", "true"),
              (this.content.parentNode.style.zIndex = 1e3),
              this.content.classList.contains("invert-with-fixed") &&
                this.content.getBoundingClientRect().y +
                  this.content.offsetHeight +
                  55 >
                  window.innerHeight &&
                this.content.classList.add("invert"),
              (this.onClickHandler = (() => {
                this.content.classList.contains("content-opened") &&
                  (this.content.classList.remove("content-opened", "invert"),
                  (this.content.parentNode.style.zIndex = 9));
              }).bind(this)),
              window.addEventListener("click", this.onClickHandler));
      }),
      this.querySelector(".regular-select-cover").addEventListener(
        "keydown",
        function (e) {
          e.keyCode == window.KEYCODES.RETURN &&
            (this.content.classList.contains("opened-with-tab") ||
              (this.content.classList.add("opened-with-tab"),
              this.content
                .querySelectorAll(".regular-select-item")
                .forEach((e) => {
                  e.setAttribute("tabindex", "0");
                })));
        }
      );
  }
}
customElements.define("localization-form", LocalizationForm);
class ModalBox extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this.o = {
        show: 10,
        frequency: "day",
        enabled: !0,
        ...JSON.parse(this.dataset.options),
      }),
      (this._modalKey = `modal-${document.location.hostname}-${this.id}`),
      (this._modalStorage = localStorage.getItem(this._modalKey)
        ? JSON.parse(localStorage.getItem(this._modalKey))
        : "empty"),
      (this._modalText = this.extractText(
        this.querySelector("[data-content]")
      )),
      this.o.enabled)
    ) {
      const e = new Date().getTime(),
        t = Math.round((e - this._modalStorage.shown) / 1e3);
      let o = !1;
      ("empty" == this._modalStorage ||
        ("day" == this.o.frequency && t > 86400) ||
        ("week" == this.o.frequency && t > 604800) ||
        ("month" == this.o.frequency && t > 2419200) ||
        this._modalStorage.content != this._modalText) &&
        (o = !0),
        o &&
          (setTimeout(() => {
            this.show();
          }, parseInt(1e3 * this.o.show)),
          setTimeout(() => {
            this.querySelectorAll("[data-close]").forEach((e) =>
              e.addEventListener("click", () => {
                this.hide(!0);
              })
            );
          }, 100));
    }
    this.setAttribute("style", "");
  }
  show() {
    window.preloadImages(this), this.classList.add("active");
  }
  hide(e = !1) {
    this.classList.remove("active"),
      e &&
        !Shopify.designMode &&
        localStorage.setItem(
          this._modalKey,
          JSON.stringify({
            shown: new Date().getTime(),
            content: this._modalText,
          })
        );
  }
  extractText(e) {
    let t = document.createElement("span");
    t.innerHTML = e.innerHTML;
    const o = t.textContent || t.innerText;
    return t.remove(), [o].toString().replace(/ +/g, "");
  }
}
customElements.define("modal-box", ModalBox),
  document.addEventListener("shopify:section:select", (e) => {
    e.target.classList.contains("mount-popup") &&
      e.target.querySelector("modal-box").show();
  }),
  document.addEventListener("shopify:section:deselect", (e) => {
    e.target.classList.contains("mount-popup") &&
      e.target.querySelector("modal-box").hide();
  });
class ProductVariants extends HTMLElement {
  constructor() {
    super(),
      (this.price = document.querySelector(
        "#product-price-" + this.dataset.id
      )),
      this.price &&
        ((this.priceOriginal = this.price.querySelector(
          ".product__price--original"
        )),
        (this.priceCompare = this.price.querySelector(
          ".product__price--compare"
        )),
        (this.priceUnit = this.price.querySelector(".product__price--unit"))),
      (this.productForm = document.querySelector(
        "#product-form-" + this.dataset.id
      )),
      this.productForm &&
        ((this.productQty =
          this.productForm.querySelector(".product__quantity")),
        (this.addToCart = this.productForm.querySelector(
          ".product__add-to-cart"
        )),
        (this.addToCartText =
          this.productForm.querySelector(".add-to-cart__text"))),
      this.addEventListener("change", this.onVariantChange),
      this.updateOptions(),
      this.updateMasterId(),
      this.updateUnavailableVariants(),
      (this.productStock = this.querySelector(".variant-quantity")),
      this.productStock &&
        this.querySelector(".variant-quantity-data") &&
        (this.productStockData = JSON.parse(
          this.querySelector(".variant-quantity-data").dataset.inventory
        )),
      this.updateStock(),
      (this._event = new Event("VARIANT_CHANGE"));
  }
  onVariantChange() {
    this.updateOptions(),
      this.updateMasterId(),
      this.updateVariantInput(),
      this.price && this.updatePrice(),
      this.updateStock(),
      this.updateUnavailableVariants(),
      this.updatePickupAvailability(),
      this.hasAttribute("data-no-history") || this.updateURL(),
      this.updateDetails(),
      this.productForm &&
        (this.currentVariant && this.currentVariant.available
          ? (this.productQty && (this.productQty.style.display = ""),
            this.addToCart.classList.remove("disabled"),
            this.productForm.classList.remove("disabled-cart"),
            (this.addToCartText.textContent =
              KROWN.settings.locales.products_add_to_cart_button))
          : (this.productQty && (this.productQty.style.display = "none"),
            this.addToCart.classList.add("disabled"),
            this.productForm.classList.add("disabled-cart"),
            (this.addToCartText.textContent =
              KROWN.settings.locales.products_sold_out_variant)),
        this.currentVariant
          ? this.productForm.classList.remove("unavailable-variant")
          : (this.productForm.classList.add("unavailable-variant"),
            (this.addToCartText.textContent =
              KROWN.settings.locales.products_unavailable_variant))),
      this.dispatchEvent(this._event);
  }
  updateOptions() {
    "select" == this.dataset.type
      ? (this.options = Array.from(
          this.querySelectorAll(".product-variant-container"),
          (t) => t.value
        ))
      : "radio" == this.dataset.type &&
        ((this.options = []),
        this.querySelectorAll(".product-variant__input").forEach((t) => {
          t.checked && this.options.push(t.value);
        }));
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find(
      (t) => !t.options.map((t, e) => this.options[e] === t).includes(!1)
    );
  }
  updatePrice() {
    this.currentVariant
      ? ((this.priceOriginal.innerHTML = KROWN.helpers.formatMoney(
          this.currentVariant.price,
          KROWN.settings.shop_money_format
        )),
        this.currentVariant.compare_at_price > this.currentVariant.price
          ? ((this.priceCompare.innerHTML = KROWN.helpers.formatMoney(
              this.currentVariant.compare_at_price,
              KROWN.settings.shop_money_format
            )),
            (this.priceCompare.style.display = ""))
          : (this.priceCompare.style.display = "none"),
        this.currentVariant.unit_price_measurement
          ? (this.priceUnit.innerHTML = `\n\t\t\t\t\t${KROWN.helpers.formatMoney(
              this.currentVariant.unit_price,
              KROWN.settings.shop_money_format
            )} / \n\t\t\t\t\t${
              1 != this.currentVariant.unit_price_measurement.reference_value
                ? this.currentVariant.unit_price_measurement.reference_value +
                  " "
                : ""
            }\n\t\t\t\t\t${
              this.currentVariant.unit_price_measurement.reference_unit
            }\n\t\t\t\t`)
          : (this.priceUnit.innerHTML = ""))
      : ((this.priceOriginal.innerHTML = ""),
        (this.priceCompare.style.display = "none"),
        (this.priceUnit.innerHTML = ""));
  }
  updateStock() {
    if (this.currentVariant) {
      if (this.productStock && this.productStockData) {
        let t = !1;
        for (const e of this.productStockData)
          if (e.id == this.currentVariant.id) {
            t = e;
            break;
          }
        (this.productStock.innerHTML = ""),
          t &&
            (t.quantity <= 0
              ? "continue" == t.inventory
                ? (this.productStock.innerHTML =
                    KROWN.settings.locales.products_preorder)
                : "deny" == t.inventory &&
                  (this.productStock.innerHTML =
                    KROWN.settings.locales.products_no_products)
              : "1" == t.quantity
              ? (this.productStock.innerHTML =
                  KROWN.settings.locales.products_one_product)
              : t.quantity <= 5
              ? (this.productStock.innerHTML =
                  KROWN.settings.locales.products_few_products.replace(
                    "{{ count }}",
                    t.quantity
                  ))
              : t.unavailable
              ? (this.productStock.innerHTML =
                  KROWN.settings.locales.products_no_products)
              : t.quantity > 5 &&
                "always" == this.productStock.dataset.type &&
                (this.productStock.innerHTML =
                  KROWN.settings.locales.products_few_products.replace(
                    "{{ count }}",
                    t.quantity
                  )));
      }
    } else this.productStock && (this.productStock.innerHTML = "");
  }
  updateDetails() {
    document
      .querySelectorAll(`#product-${this.dataset.id} .product__sku`)
      .forEach((t) => {
        this.currentVariant.sku
          ? (t.innerHTML =
              KROWN.settings.locales.product_sku + this.currentVariant.sku)
          : (t.innerHTML = "");
      }),
      document
        .querySelectorAll(`#product-${this.dataset.id} .product__barcode`)
        .forEach((t) => {
          this.currentVariant.barcode
            ? (t.innerHTML =
                KROWN.settings.locales.product_sku +
                this.currentVariant.barcode)
            : (t.innerHTML = "");
        });
  }
  updatePickupAvailability() {
    const t = document.querySelector("pickup-availability");
    t &&
      (this.currentVariant && this.currentVariant.available
        ? t.fetchAvailability(this.currentVariant.id)
        : (t.removeAttribute("available"), (t.innerHTML = "")));
  }
  updateUnavailableVariants() {
    if ("true" == this.dataset.hideVariants) {
      let t = {},
        e = {},
        i = {},
        r = null,
        a = null;
      this.dataset.variants > 1 &&
        ((r = this._getSelectedOption(0)), this._resetDisabledOption(1)),
        this.dataset.variants > 2 &&
          ((a = this._getSelectedOption(1)), this._resetDisabledOption(2)),
        this.getVariantData().forEach((s) => {
          this.dataset.variants > 0 &&
            (t[s.option1] || (t[s.option1] = []),
            t[s.option1].push(String(s.available))),
            this.dataset.variants > 1 &&
              (e[s.option2] || (e[s.option2] = []),
              e[s.option2].push(String(s.available))),
            2 == this.dataset.variants &&
              (s.option1 != r ||
                s.available ||
                this._setDisabledOption(1, s.option2)),
            this.dataset.variants > 2 &&
              (i[s.option3] || (i[s.option3] = []),
              i[s.option3].push(String(s.available)),
              s.option2 != a ||
                s.option1 != r ||
                s.available ||
                this._setDisabledOption(2, s.option3));
        }),
        this.dataset.variants > 0 &&
          Object.keys(t).forEach((e) => {
            t[e].includes("true") ||
              this.querySelectorAll(".product-variant")[0]
                .querySelector(`.product-variant-value[value="${e}"]`)
                .setAttribute("disabled", "disabled");
          }),
        this.dataset.variants > 1 &&
          Object.keys(e).forEach((t) => {
            e[t].includes("true") ||
              this.querySelectorAll(".product-variant")[1]
                .querySelector(`.product-variant-value[value="${t}"]`)
                .setAttribute("disabled", "disabled");
          }),
        this.dataset.variants > 2 &&
          (Object.keys(i).forEach((t) => {
            i[t].includes("true") ||
              this.querySelectorAll(".product-variant")[2]
                .querySelector(`.product-variant-value[value="${t}"]`)
                .setAttribute("disabled", "disabled");
          }),
          Object.keys(e).forEach((t) => {
            e[t].includes("true") ||
              (a == t &&
                this.querySelectorAll(".product-variant")[2]
                  .querySelector(".product-variant-value")
                  .setAttribute("disabled", "disabled"));
          }));
    }
  }
  _getSelectedOption(t) {
    if ("select" == this.dataset.type)
      return this.querySelectorAll(".product-variant")[t].querySelector(
        ".product-variant-container"
      ).value;
    if ("radio" == this.dataset.type) {
      let e = null;
      return (
        this.querySelectorAll(".product-variant")
          [t].querySelectorAll(".product-variant__input")
          .forEach((t) => {
            t.checked && (e = t.value);
          }),
        e
      );
    }
  }
  _resetDisabledOption(t) {
    this.querySelectorAll(".product-variant")
      [t].querySelectorAll(".product-variant-value")
      .forEach((t) => {
        t.removeAttribute("disabled");
      });
  }
  _setDisabledOption(t, e) {
    this.querySelectorAll(".product-variant")
      [t].querySelector(`.product-variant-value[value="${e}"]`)
      .setAttribute("disabled", "disabled");
  }
  updateURL() {
    this.currentVariant &&
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`
      );
  }
  updateVariantInput() {
    if (!this.currentVariant) return;
    document
      .querySelectorAll(
        `#product-form-${this.dataset.id}, #product-form-installment`
      )
      .forEach((t) => {
        const e = t.querySelector('input[name="id"]');
        (e.value = this.currentVariant.id),
          e.dispatchEvent(new Event("change", { bubbles: !0 }));
      });
  }
  getVariantData() {
    return (
      (this.variantData =
        this.variantData ||
        JSON.parse(
          this.querySelector('[type="application/json"]').textContent
        )),
      this.variantData
    );
  }
}
customElements.define("product-variants", ProductVariants);
class ProductForm extends HTMLElement {
  constructor() {
    super(), this.init();
  }
  init() {
    this.hasAttribute("data-ajax-cart") &&
      !document.body.classList.contains("template-cart") &&
      ((this.form = this.querySelector("form")),
      this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
      (this.ADD_TO_CART = new Event("add-to-cart")));
  }
  onSubmitHandler(t) {
    t.preventDefault();
    const e = this.querySelector('[type="submit"]');
    e.classList.add("working");
    const i = serializeForm(this.form);
    let r = "";
    fetch(KROWN.settings.routes.cart_add_url + ".js", {
      body: i,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-Requested-With": "XMLHttpRequest",
      },
      method: "POST",
    })
      .then((t) => t.json())
      .then((t) =>
        422 == t.status
          ? ((r = document.createElement("span")),
            (r.className = "alert body-text-sm alert--error"),
            (r.innerHTML = t.description),
            fetch("?section_id=cart-helper"))
          : fetch("?section_id=cart-helper")
      )
      .then((t) => t.text())
      .then((t) => {
        const e = new DOMParser().parseFromString(t, "text/html"),
          i = e.getElementById("AjaxCartForm").innerHTML,
          a = e.getElementById("AjaxCartSubtotal").innerHTML,
          s = document.getElementById("AjaxCartForm");
        (s.innerHTML = i),
          s.ajaxifyCartItems(),
          "" != r &&
            document
              .getElementById("AjaxCartForm")
              .querySelector("form")
              .prepend(r),
          (document.getElementById("AjaxCartSubtotal").innerHTML = a),
          window.preloadImages(s),
          (document.querySelector("[data-header-cart-count]").textContent =
            document.querySelector(
              "#AjaxCartForm [data-cart-count]"
            ).textContent),
          this.dispatchEvent(this.ADD_TO_CART);
      })
      .catch((t) => {
        console.log(t);
      })
      .finally(() => {
        e.classList.remove("working");
      });
  }
}
customElements.define("product-form", ProductForm);
class PickupAvailability extends HTMLElement {
  constructor() {
    super(),
      (this.errorHtml = this.querySelector(
        "template"
      ).content.firstElementChild.cloneNode(!0)),
      (this.onClickRefreshList = this.onClickRefreshList.bind(this)),
      this.hasAttribute("available") &&
        this.fetchAvailability(this.dataset.variantId);
  }
  fetchAvailability(t) {
    const e = `${this.dataset.baseUrl}variants/${t}/?section_id=pickup-availability`;
    fetch(e)
      .then((t) => t.text())
      .then((t) => {
        const e = new DOMParser()
          .parseFromString(t, "text/html")
          .querySelector(".shopify-section");
        this.renderPreview(e);
      })
      .catch((t) => {
        console.log(t),
          this.querySelector("button") &&
            this.querySelector("button").removeEventListener(
              "click",
              this.onClickRefreshList
            ),
          this.renderError();
      });
  }
  onClickRefreshList() {
    this.fetchAvailability(this.dataset.variantId);
  }
  renderError() {
    (this.innerHTML = ""),
      this.appendChild(this.errorHtml),
      this.querySelector("button").addEventListener(
        "click",
        this.onClickRefreshList
      );
  }
  renderPreview(t) {
    const e = document.getElementById("PickupAvailabilityDrawer");
    if ((e && e.remove(), !t.querySelector("pickup-availability-preview")))
      return (this.innerHTML = ""), void this.removeAttribute("available");
    (this.innerHTML = t.querySelector("pickup-availability-preview").outerHTML),
      this.setAttribute("available", ""),
      document.body.appendChild(t.querySelector("#PickupAvailabilityDrawer")),
      this.querySelector("button").addEventListener("click", (t) => {
        document.getElementById("PickupAvailabilityDrawer").show(t.target);
      }),
      this.querySelector("button").addEventListener("keyup", (t) => {
        t.keyCode == window.KEYCODES.RETURN &&
          document
            .getElementById("PickupAvailabilityDrawer")
            .querySelector("[data-close]")
            .focus();
      });
  }
}
customElements.define("pickup-availability", PickupAvailability);
class ProductImageZoom extends HTMLElement {
  constructor() {
    super(),
      document.getElementById("zoom")
        ? (this.zoom = document.getElementById("zoom"))
        : ((this.zoom = document.createElement("div")),
          (this.zoom.id = "zoom"),
          (this.zoom.innerHTML = `\n\t\t\t\t<img />\n\t\t\t\t<span class="zoom__exit">${KROWN.settings.symbols.zoom_out}</span>\n\t\t\t\t<div class="zoom__overlay"></div>\n\t\t\t`),
          document.body.append(this.zoom),
          this.zoom
            .querySelector(".zoom__exit")
            .addEventListener("click", this._productZoomUnmount.bind(this))),
      (this.onMouseMoveHandlerBinded = this.onMouseMoveHandler.bind(this)),
      (this.onResizeHandlerBinded = this.onResizeHandler.bind(this)),
      this.addEventListener("click", (t) => {
        this.zoom.classList.add("opened"),
          (this.image = this.zoom.querySelector("img")),
          (this.image.src = this.getAttribute("data-image")),
          this.image.naturalWidth > 0
            ? this._productZoomMount()
            : this.image.addEventListener(
                "load",
                this._productZoomMount.bind(this)
              );
      });
  }
  onMouseMoveHandler(t) {
    (window.clientX = t.clientX), (window.clientY = t.clientY);
    const e =
        (t.clientX * (window.innerWidth - this.image.offsetWidth)) /
        window.innerWidth,
      i =
        (t.clientY * (window.innerHeight - this.image.offsetHeight)) /
        window.innerHeight;
    (this.image.style.left = e + "px"), (this.image.style.top = i + "px");
  }
  onResizeHandler() {
    const t = window.innerWidth > 768 ? 1 : 2;
    this.image.classList.contains("portrait")
      ? ((this.image.style.width = window.innerWidth * t + "px"),
        (this.image.style.height =
          (window.innerWidth * t) / this.image.dataset.ratio + "px"))
      : ((this.image.style.height = window.innerHeight * t + "px"),
        (this.image.style.width =
          window.innerHeight * t * this.image.dataset.ratio + "px"),
        this.image.offsetWidth < window.innerWidth &&
          ((this.image.style.width = window.innerWidth * t + "px"),
          (this.image.style.height =
            (window.innerWidth * t) / this.image.dataset.ratio + "px")));
    window.clientX,
      window.innerWidth,
      this.image.offsetWidth,
      window.innerWidth,
      window.clientY,
      window.innerHeight,
      this.image.offsetHeight,
      window.innerHeight;
  }
  _productZoomMount(t) {
    (this.image.style.left = 0),
      (this.image.style.top = 0),
      window.addEventListener("mousemove", this.onMouseMoveHandlerBinded, {
        passive: !0,
      }),
      (this.image.dataset.ratio =
        this.image.naturalWidth / this.image.naturalHeight),
      window.addEventListener("resize", this.onResizeHandlerBinded, {
        passive: !0,
      }),
      this.onResizeHandler(),
      setTimeout(() => {
        (document.body.classList.contains("touch") ||
          document.body.classList.contains("touchevents")) &&
          ((this.zoom.scrollTop =
            (window.innerHeight - this.image.offsetHeight) / -2),
          (this.zoom.scrollLeft =
            (window.innerWidth - this.image.offsetWidth) / -2)),
          this.zoom.classList.add("loaded");
      }, 50);
  }
  _productZoomUnmount() {
    this.zoom.classList.remove("opened"),
      setTimeout(() => {
        window.removeEventListener("resize", this.onResizeHandlerBinded),
          window.removeEventListener(
            "mousemove",
            this.onMouseMoveHandlerBinded
          );
        const t = document.querySelector("#zoom img");
        (t.src = ""),
          (t.className = ""),
          (t.style = ""),
          this.zoom.classList.remove("loaded");
      }, 300);
  }
}
customElements.define("product-image-zoom", ProductImageZoom);
class SearchForm extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this.cachedResults = {}),
      (this.input = this.querySelector("[data-search-input]")),
      (this.predictiveSearchResults = this.querySelector(
        "[data-search-results]"
      )),
      (this.results = []),
      (this.preloader = !1),
      "false" != KROWN.settings.predictive_search_enabled)
    ) {
      let e = this.input.value;
      this.input.addEventListener(
        "keyup",
        debounce((t) => {
          this.input.value != e
            ? ((e = this.input.value),
              this.getSearchResults(this.input.value.trim()))
            : "" == this.input.value && this.clearSearchResults();
        }, 150)
      ),
        this.input.addEventListener("keydown", (e) => {
          -1 != this.a11yIndex &&
            ((e.keyCode !== window.KEYCODES.UP &&
              e.keyCode !== window.KEYCODES.DOWN &&
              e.keyCode !== window.KEYCODES.RETURN) ||
              e.preventDefault());
        }),
        this.input.addEventListener("keyup", (e) =>
          e.keyCode === window.KEYCODES.UP
            ? (this.navigateThrough("UP"), !0)
            : e.keyCode === window.KEYCODES.DOWN
            ? (this.navigateThrough("DOWN"), !0)
            : void (
                e.keyCode === window.KEYCODES.RETURN &&
                -1 != this.a11yIndex &&
                (document.location.href =
                  this.results[this.a11yIndex].querySelector("a"))
              )
        );
    }
  }
  getSearchResults(e = "") {
    this.preloadSearchResults();
    const t = e.replace(" ", "-").toLowerCase();
    this.cachedResults[t]
      ? this.renderSearchResults(this.cachedResults[t])
      : ((this.a11yIndex = -1),
        fetch(
          `${
            KROWN.settings.routes.predictive_search_url
          }?q=${encodeURIComponent(e)}&resources[type]=${
            this.dataset.resourceType
          }&resources[limit]=4&section_id=predictive-search`
        )
          .then((e) => {
            if (!e.ok) {
              var t = new Error(e.status);
              throw (this.clearSearchResults(), t);
            }
            return e.text();
          })
          .then((e) => {
            const s = new DOMParser()
              .parseFromString(e, "text/html")
              .querySelector("#shopify-section-predictive-search").innerHTML;
            (this.cachedResults[t] = s), this.renderSearchResults(s);
          })
          .catch((e) => {
            throw e;
          }));
  }
  clearSearchResults() {
    (this.predictiveSearchResults.innerHTML = ""),
      (this.preloader = !1),
      (this.results = []);
  }
  preloadSearchResults() {
    this.preloader ||
      ((this.preloader = !0),
      (this.predictiveSearchResults.innerHTML =
        KROWN.settings.predictive_search_placeholder));
  }
  renderSearchResults(e) {
    (this.predictiveSearchResults.innerHTML = e),
      (this.preloader = !1),
      (this.results = this.predictiveSearchResults.querySelectorAll(
        ".search-item, .sidebar__search-link"
      )),
      window.preloadImages(this.predictiveSearchResults);
  }
  navigateThrough(e) {
    -1 == this.a11yIndex
      ? (this.a11yIndex = 0)
      : (this.results[this.a11yIndex].classList.remove("active"),
        "UP" == e
          ? this.a11yIndex - 1 >= -1 && this.a11yIndex--
          : "DOWN" == e &&
            this.a11yIndex + 1 < this.results.length &&
            this.a11yIndex++),
      this.a11yIndex >= 0
        ? (this.results[this.a11yIndex].classList.add("active"),
          (document.getElementById("site-search-sidebar").scrollTop =
            this.results[this.a11yIndex].offsetTop - 200))
        : (document.getElementById("site-search-sidebar").scrollTop = 0);
  }
}
customElements.define("search-form", SearchForm);
class ToggleTab extends HTMLElement {
  constructor() {
    super(),
      (this.titleEl = this.querySelector(".toggle__title")),
      (this.contentEl = this.querySelector(".toggle__content")),
      (this.titleEl.innerHTML = `${this.titleEl.innerHTML}${KROWN.settings.symbols.toggle_pack}`),
      this.titleEl.addEventListener("click", this.onClickHandler.bind(this)),
      this.titleEl.addEventListener("keydown", (t) => {
        t.keyCode == window.KEYCODES.RETURN && this.onClickHandler();
      });
  }
  onClickHandler() {
    this.titleEl.classList.contains("opened")
      ? (this.titleEl.classList.remove("opened"),
        this.titleEl.setAttribute("aria-expanded", "false"),
        this.slideUp(this.contentEl, 200))
      : (this.titleEl.classList.add("opened"),
        this.titleEl.setAttribute("aria-expanded", "true"),
        this.slideDown(this.contentEl, 200));
  }
  slideUp(t, e) {
    (t.style.transitionProperty = "height, margin, padding"),
      (t.style.transitionDuration = e + "ms"),
      (t.style.boxSizing = "border-box"),
      (t.style.height = t.offsetHeight + "px"),
      t.offsetHeight,
      (t.style.overflow = "hidden"),
      (t.style.height = 0),
      (t.style.paddingTop = 0),
      (t.style.paddingBottom = 0),
      (t.style.marginTop = 0),
      (t.style.marginBottom = 0),
      setTimeout(() => {
        (t.style.display = "none"),
          t.style.removeProperty("height"),
          t.style.removeProperty("padding-top"),
          t.style.removeProperty("padding-bottom"),
          t.style.removeProperty("margin-top"),
          t.style.removeProperty("margin-bottom"),
          t.style.removeProperty("overflow"),
          t.style.removeProperty("transition-duration"),
          t.style.removeProperty("transition-property");
      }, e);
  }
  slideDown(t, e) {
    t.style.removeProperty("display");
    var o = window.getComputedStyle(t).display;
    "none" === o && (o = "block"), (t.style.display = o);
    var i = t.offsetHeight;
    (t.style.overflow = "hidden"),
      (t.style.height = 0),
      (t.style.paddingTop = 0),
      (t.style.paddingBottom = 0),
      (t.style.marginTop = 0),
      (t.style.marginBottom = 0),
      t.offsetHeight,
      (t.style.boxSizing = "border-box"),
      (t.style.transitionProperty = "height, margin, padding"),
      (t.style.transitionDuration = e + "ms"),
      (t.style.height = i + "px"),
      t.style.removeProperty("padding-top"),
      t.style.removeProperty("padding-bottom"),
      t.style.removeProperty("margin-top"),
      t.style.removeProperty("margin-bottom"),
      setTimeout(() => {
        t.style.removeProperty("height"),
          t.style.removeProperty("overflow"),
          t.style.removeProperty("transition-duration"),
          t.style.removeProperty("transition-property");
      }, e);
  }
}
customElements.define("toggle-tab", ToggleTab),
  document.addEventListener("shopify:block:select", (t) => {
    const e = t.target;
    e.classList.contains("toggle") &&
      (e.querySelector(".toggle__title").classList.contains("opened") ||
        e.onClickHandler());
  }),
  document.addEventListener("shopify:block:deselect", (t) => {
    const e = t.target;
    e.classList.contains("toggle") &&
      e.querySelector(".toggle__title").classList.contains("opened") &&
      e.onClickHandler();
  });
const isAutoplaySupported = (A) => {
  if ("function" != typeof A) return !1;
  if (sessionStorage.getItem("autoplaySupported"))
    "true" == sessionStorage.getItem("autoplaySupported") ? A(!0) : A(!1);
  else {
    const e =
      "data:video/mp4;base64,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";
    let t = !1,
      o = document.createElement("video");
    o.setAttribute("playsinline", "playsinline"),
      o.setAttribute("muted", "muted"),
      o.setAttribute("autoplay", "autoplay"),
      o.setAttribute("loop", "loop"),
      o.setAttribute("controls", "controls"),
      o.setAttribute("width", 20),
      o.setAttribute("height", 20),
      (o.onplay = () => {
        t = !0;
      }),
      o.setAttribute("src", e),
      (o.style.position = "fixed"),
      (o.style.top = "-20px"),
      (o.style.left = "0px"),
      (o.style.zIndex = "997"),
      document.querySelector("body").appendChild(o);
    let s = o.play();
    void 0 !== s &&
      s
        .then(() => {
          A(!0),
            sessionStorage.setItem("autoplaySupported", "true"),
            o.remove();
        })
        .catch((e) => {
          t || e.toString().includes("interact with the document")
            ? (A(!0), sessionStorage.setItem("autoplaySupported", "true"))
            : (A(!1), sessionStorage.setItem("autoplaySupported", "false")),
            o.remove();
        });
  }
};
class VideoPopup extends HTMLElement {
  constructor() {
    super(),
      this.querySelector(".video-popup__link").addEventListener(
        "click",
        (A) => {
          A.preventDefault();
          const e = document.createElement("div");
          e.classList.add("video-popup__blackout"),
            this.append(e),
            setTimeout(() => {
              e.style.opacity = "1";
            }, 10),
            this.classList.add("video-opened"),
            this.querySelector(".video-popup__close") &&
              this.querySelector(".video-popup__close").addEventListener(
                "click",
                (A) => {
                  this.querySelectorAll("iframe, video").forEach((A) => {
                    A.remove();
                  }),
                    e.remove(),
                    this.classList.remove("video-opened");
                }
              ),
            setTimeout(() => {
              pauseAllMedia(),
                this.querySelector(".video-popup__container").appendChild(
                  this.querySelector(
                    "template"
                  ).content.firstElementChild.cloneNode(!0)
                ),
                setTimeout(() => {
                  playMedia(this.closest("[data-video]"));
                }, 500);
            }, 50);
        }
      );
  }
}
customElements.define("video-popup", VideoPopup);
class VideoBackground extends HTMLElement {
  constructor() {
    super(),
      isAutoplaySupported((A) => {
        if (A) {
          const A = this.querySelector(".video-text__background");
          A &&
            ((A.innerHTML = `<video autoplay muted loop playsinline><source type="video/mp4" src="${A.dataset.src}"></video>`),
            A.querySelector("video").play(),
            setTimeout(() => {
              A.querySelector("video").style.opacity = "1";
            }, 200));
        } else
          this.querySelector(
            ".video-text__background .video-text__image"
          ).style.display = "block";
      });
  }
}
customElements.define("video-background", VideoBackground);
function debounce(e, t) {
  let o;
  return (...a) => {
    clearTimeout(o), (o = setTimeout(() => e.apply(this, a), t));
  };
}
KROWN.helpers = {
  formatMoney: function (e, t) {
    "string" == typeof e && (e = e.replace(".", ""));
    let o = "";
    const a = /\{\{\s*(\w+)\s*\}\}/,
      n = t || moneyFormat;
    function r(e, t, o, a) {
      if (((o = o || ","), (a = a || "."), isNaN(e) || null === e)) return 0;
      const n = (e = (e / 100).toFixed(t)).split(".");
      return (
        n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + o) +
        (n[1] ? a + n[1] : "")
      );
    }
    switch (n.match(a)[1]) {
      case "amount":
        o = r(e, 2);
        break;
      case "amount_no_decimals":
        o = r(e, 0);
        break;
      case "amount_with_comma_separator":
        o = r(e, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        o = r(e, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        o = r(e, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        o = r(e, 2, "'");
    }
    return n.replace(a, o);
  },
};
const getPseudoContent = (e) => {
    var t = document.querySelector(e);
    return window.getComputedStyle(t, ":after").getPropertyValue("content");
  },
  pauseAllMedia = () => {
    document.querySelectorAll(".product .js-youtube").forEach((e) => {
      e.contentWindow.postMessage(
        '{"event":"command","func":"pauseVideo","args":""}',
        "*"
      );
    }),
      document.querySelectorAll(".product .js-vimeo").forEach((e) => {
        e.contentWindow.postMessage('{"method":"pause"}', "*");
      }),
      document.querySelectorAll(".product video").forEach((e) => e.pause()),
      document.querySelectorAll(".product product-model").forEach((e) => {
        e.modelViewerUI && e.modelViewerUI.pause();
      });
  },
  playMedia = (e) => {
    switch (e.dataset.productMediaType) {
      case "video":
        e.querySelector("video").play();
        break;
      case "external_video-youtube":
        e.querySelector(".js-youtube").contentWindow.postMessage(
          '{"event":"command","func":"playVideo","args":""}',
          "*"
        );
        break;
      case "external_video-vimeo":
        e.querySelector(".js-vimeo").contentWindow.postMessage(
          '{"method":"play"}',
          "*"
        );
    }
  },
  /*!
   * Serialize all form data into a SearchParams string
   * (c) 2020 Chris Ferdinandi, MIT License, https://gomakethings.com
   * @param  {Node}   form The form to serialize
   * @return {String}      The serialized form data
   */ serializeForm = (e) => {
    let t = [];
    return (
      Array.prototype.slice.call(e.elements).forEach(function (e) {
        !e.name ||
          e.disabled ||
          ["file", "reset", "submit", "button"].indexOf(e.type) > -1 ||
          ("select-multiple" !== e.type
            ? (["checkbox", "radio"].indexOf(e.type) > -1 && !e.checked) ||
              t.push(
                encodeURIComponent(e.name) + "=" + encodeURIComponent(e.value)
              )
            : Array.prototype.slice.call(e.options).forEach(function (o) {
                o.selected &&
                  t.push(
                    encodeURIComponent(e.name) +
                      "=" +
                      encodeURIComponent(o.value)
                  );
              }));
      }),
      t.join("&")
    );
  },
  getJSONP = (e, t) => {
    var o = "_" + +new Date(),
      a = document.createElement("script"),
      n = document.getElementsByTagName("head")[0] || document.documentElement;
    (window[o] = function (e) {
      n.removeChild(a), t && t(e);
    }),
      (a.src = e.replace("callback=?", "callback=" + o)),
      n.appendChild(a);
  },
  trueTypeOf = (e) =>
    Object.prototype.toString.call(e).slice(8, -1).toLowerCase(),
  htmlEscape = (e) =>
    e
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;"),
  reframe = (e, t) => {
    let o = "string" == typeof e ? document.querySelectorAll(e) : e;
    const a = t || "js-reframe";
    "length" in o || (o = [o]);
    for (let e = 0; e < o.length; e += 1) {
      const t = o[e];
      if (
        -1 !== t.className.split(" ").indexOf(a) ||
        t.style.width.indexOf("%") > -1
      )
        continue;
      const n =
          ((t.getAttribute("height") || t.offsetHeight) /
            (t.getAttribute("width") || t.offsetWidth)) *
          100,
        r = document.createElement("div");
      r.className = a;
      const c = r.style;
      (c.position = "relative"), (c.width = "100%"), (c.paddingTop = n + "%");
      const l = t.style;
      (l.position = "absolute"),
        (l.width = "100%"),
        (l.height = "100%"),
        (l.left = "0"),
        (l.top = "0"),
        t.parentNode.insertBefore(r, t),
        t.parentNode.removeChild(t),
        r.appendChild(t);
    }
  };
window.KEYCODES = {
  TAB: 9,
  ESC: 27,
  DOWN: 40,
  RIGHT: 39,
  UP: 38,
  LEFT: 37,
  RETURN: 13,
};
class CSSSlider extends HTMLElement {
  constructor() {
    super();
    const s = navigator.userAgent.toLowerCase();
    (this._ios15 = s.includes("applewebkit") && s.includes("version/15")),
      this.initSlider();
  }
  destroySlider() {
    this.classList.remove("enabled"),
      (this.sliderEnabled = !1),
      window.removeEventListener("resize", this.RESIZE_EVENT),
      window.removeEventListener("scroll", this.SCROLL_EVENT),
      window.preloadImages(this);
  }
  initSlider() {
    (this._readyEvent = new CustomEvent("ready")),
      (this._changeEvent = new CustomEvent("change")),
      (this._scrollEvent = new CustomEvent("scroll")),
      (this._navEvent = new CustomEvent("navigation")),
      (this._pointerDownEvent = new CustomEvent("pointerDown")),
      (this._pointerUpEvent = new CustomEvent("pointerUp")),
      window.preloadImages(this),
      (this.items = this.querySelectorAll(".css-slide[data-index]")),
      (this.indexedItems = []),
      (this.index = 0),
      (this.length = this.items.length),
      (this.windowWidth = window.innerWidth),
      (this.scrollLeft = 0),
      this.length > 1
        ? ((this.navigation = document.createElement("div")),
          (this.navigation.classList =
            "css-slider-navigation " +
            this.getAttribute("data-navigation-class")),
          (this.navigation.style.display = "none"),
          (this.navigation.innerHTML = `<div>\n          <span class="css-slider-navigation__index">0</span> / <span class="css-slider-navigation__length">0</span>\n        </div>\n        <button class="css-slider-navigation__prev simple-arrow simple-arrow--left disabled">\n          <span class="visually-hidden">${KROWN.settings.locales.prev}</span>\n          ${KROWN.settings.symbols.arrow}\n        </button>\n        <button class="css-slider-navigation__next simple-arrow simple-arrow--right">\n          <span class="visually-hidden">${KROWN.settings.locales.next}</span>\n          ${KROWN.settings.symbols.arrow}\n        </button>`),
          this.classList.contains("css-slider--auto-height")
            ? this.parentNode.parentNode.insertBefore(
                this.navigation,
                this.parentNode.nextSibling
              )
            : this.parentNode.insertBefore(this.navigation, this.nextSibling),
          (this.indexEl = this.navigation.querySelector(
            ".css-slider-navigation__index"
          )),
          (this.lengthEl = this.navigation.querySelector(
            ".css-slider-navigation__length"
          )),
          (this.prevEl = this.navigation.querySelector(
            ".css-slider-navigation__prev"
          )),
          (this.nextEl = this.navigation.querySelector(
            ".css-slider-navigation__next"
          )),
          this.prevEl.addEventListener("click", (s) => {
            this.changeSlide("prev");
          }),
          this.nextEl.addEventListener("click", (s) => {
            this.changeSlide("next");
          }),
          this.classList.contains("css-slider--auto-height") &&
            (this.parentNode.style.height = this.items[0].offsetHeight + "px"),
          (this.SCROLL_EVENT = debounce(() => {
            if (!this._sliderBlockScroll) {
              const s = this.indexedItems.entries(),
                e = Array.from(s, (s) =>
                  Math.abs(s[1].offsetLeft - this.scrollLeft)
                ),
                i = Math.min(...e),
                t = e.indexOf(i);
              t != this.index &&
                ((this.index = t),
                this.checkSlide(),
                this.dispatchEvent(this._changeEvent));
            }
          }, 10)),
          this.addEventListener("scroll", this.SCROLL_EVENT, { passive: !0 }),
          (this.RESIZE_EVENT = debounce(() => {
            this.windowWidth != window.innerWidth && this.resetSlider(),
              (this.windowWidth = window.innerWidth);
          }, 100)),
          window.addEventListener("resize", this.RESIZE_EVENT),
          this.resetSlider(!0),
          "ontouchstart" in window ||
            (window.DocumentTouch && document instanceof DocumentTouch) ||
            (this.addEventListener("mousedown", (s) => {
              (this.mouseX = s.screenX),
                this.classList.add("can-drag"),
                this.classList.add("mouse-down");
            }),
            this.addEventListener("mouseup", (s) => {
              this.classList.remove("mouse-down"),
                this.classList.remove("can-drag"),
                this.classList.remove("pointer-events-off");
            }),
            this.addEventListener("mouseleave", (s) => {
              this.classList.remove("mouse-down"),
                this.classList.remove("can-drag"),
                this.classList.remove("pointer-events-off");
            }),
            this.addEventListener("mousemove", (s) => {
              if (this.classList.contains("can-drag")) {
                this.classList.add("pointer-events-off");
                let e = this.mouseX - s.screenX;
                Math.abs(e) > 1 &&
                  (e > 0
                    ? (this.changeSlide("next"),
                      this.classList.remove("can-drag"))
                    : e < 0 &&
                      (this.changeSlide("prev"),
                      this.classList.remove("can-drag")));
              }
            }),
            this.querySelectorAll(".css-slides-container").forEach((s) => {
              s.addEventListener("mousedown", (s) => {
                s.preventDefault();
              });
            })))
        : 1 == this.length
        ? this.classList.add("css-slider--singular")
        : this.classList.add("css-slider--empty"),
      this.classList.add("enabled"),
      (this.sliderEnabled = !0),
      this.dispatchEvent(this._readyEvent);
  }
  changeSlide(s, e = "smooth") {
    "next" == s
      ? this.index + 1 < this.length && this.index++
      : this.index - 1 >= 0 && this.index--,
      this.checkSlide(),
      (this._sliderBlockScroll = !0),
      this._ios15 && this.classList.add("disable-snapping"),
      setTimeout(() => {
        (this._sliderBlockScroll = !1),
          this._ios15 && this.classList.remove("disable-snapping");
      }, 500),
      this.scrollTo({
        top: 0,
        left:
          this.indexedItems[this.index].offsetLeft -
          parseInt(getComputedStyle(this.indexedItems[0]).marginLeft),
        behavior: e,
      }),
      this.dispatchEvent(this._changeEvent);
  }
  checkSlide() {
    this.prevEl.classList.remove("disabled"),
      this.nextEl.classList.remove("disabled"),
      0 == this.index && this.prevEl.classList.add("disabled"),
      this.index == this.length - 1 && this.nextEl.classList.add("disabled"),
      (this.indexEl.innerHTML = this.index + 1),
      this.classList.contains("css-slider--auto-height") &&
        (this.parentNode.style.height =
          this.indexedItems[this.index].offsetHeight + "px");
  }
  afterAppend() {
    this.items = this.querySelectorAll(".css-slide[data-index]");
  }
  resetSlider(s = !1, e = !0) {
    let i = 0,
      t = 0,
      n = 0,
      a = this.classList.contains("css-slider--auto-height")
        ? window.innerWidth
        : this.querySelector(".css-slides-container").offsetWidth - 20,
      d = !1;
    (this.indexedItems = []),
      this.classList.add("disable-snapping"),
      this.items.forEach((s, e) => {
        s.classList.remove("css-slide--snap"),
          (i += s.offsetWidth),
          i > a && 0 == t && (t = e);
      }),
      0 == t && ((t = this.items.length), (d = !0)),
      this.items.forEach((s, e) => {
        e % t == 0 &&
          (s.classList.add("css-slide--snap"),
          s.setAttribute("data-index", n++));
      }),
      (this.indexedItems = this.querySelectorAll(".css-slide--snap")),
      e && (this.index = 0),
      (this.length = Math.ceil(this.items.length / t)),
      (this.lengthEl.innerHTML = this.length),
      (this.indexEl.innerHTML = 1),
      d
        ? ((this.navigation.style.display = "none"),
          this.classList.add("css-slider--no-drag"))
        : ((this.navigation.style.display = "block"),
          this.classList.remove("css-slider--no-drag")),
      s || this.scrollTo({ top: 0, left: 0, behavior: "auto" }),
      this.classList.remove("disable-snapping");
  }
}
customElements.define("css-slider", CSSSlider);
class MainHeader extends HTMLElement {
  constructor() {
    super(), this.mount();
  }
  mount() {
    const e = document.getElementById("site-cart-sidebar");
    document.getElementById("cart-open-button") &&
      (document
        .getElementById("cart-open-button")
        .addEventListener("click", (t) => {
          t.preventDefault(),
            document
              .getElementById("cart-open-button")
              .setAttribute("aria-expanded", "true"),
            e.show();
        }),
      document
        .getElementById("cart-open-button")
        .addEventListener("keyup", (t) => {
          t.keyCode == window.KEYCODES.RETURN &&
            e.querySelector(".close-sidebar").focus();
        }));
    const t = document.getElementById("site-menu-sidebar");
    document.getElementById("menu-open-button") &&
      (document
        .getElementById("menu-open-button")
        .addEventListener("click", (e) => {
          e.preventDefault(),
            document
              .getElementById("menu-open-button")
              .setAttribute("aria-expanded", "true"),
            t.show();
        }),
      document
        .getElementById("menu-open-button")
        .addEventListener("keyup", (e) => {
          e.keyCode == window.KEYCODES.RETURN &&
            t.querySelector(".close-sidebar").focus();
        }));
    const s = document.getElementById("site-search-sidebar");
    document.getElementById("search-open-button") &&
      document.getElementById("search-open-button").addEventListener(
        "click",
        function (e) {
          e.preventDefault(),
            document
              .getElementById("search-open-button")
              .setAttribute("aria-expanded", "true"),
            s.show(),
            setTimeout(() => {
              s.querySelector("[data-search-input]").focus();
            }, 10);
        }.bind(this)
      ),
      document
        .querySelectorAll(".sidebar__close button.close-sidebar")
        .forEach((e) => {
          e.addEventListener("click", (e) => {
            e.preventDefault(),
              e.target
                .closest(".sidebar")
                .classList.contains("sidebar--opened") &&
                e.target.closest(".sidebar").hide();
          });
        }),
      document.querySelector(".page-overlay").addEventListener("click", (e) => {
        document.querySelector(".sidebar--opened") &&
          document.querySelector(".sidebar--opened").hide();
      }),
      document.addEventListener("keydown", (e) => {
        e.keyCode == window.KEYCODES.ESC &&
          document.querySelector(".sidebar--opened") &&
          document.querySelector(".sidebar--opened").hide();
      }),
      (this.RESIZE_SidebarHelper = debounce(() => {
        document.querySelector(".sidebar--opened") &&
          (document.querySelector(".sidebar--opened").style.height =
            window.innerHeight + "px");
      }, 200)),
      window.addEventListener("resize", this.RESIZE_SidebarHelper);
    const n = document.querySelector(".header-holder");
    (window.lst = window.scrollY),
      (window.lhp = 0),
      (this.SCROLL_StickyHelper = () => {
        var e = window.scrollY;
        e < 0 ||
          Math.abs(lst - e) <= 5 ||
          (e <= window.lhp || 0 == e
            ? (n.classList.remove("animate"),
              n.classList.remove("fix"),
              n.classList.remove("ready"))
            : e <= lst && !n.classList.contains("fix")
            ? ((window.lhp = n.querySelector(".header").offsetTop),
              n.classList.add("fix"),
              setTimeout(() => {
                n.classList.add("ready");
              }, 5),
              setTimeout(() => {
                n.classList.add("animate");
              }, 25))
            : e > lst &&
              n.classList.contains("animate") &&
              (n.classList.remove("animate"),
              setTimeout(() => {
                n.classList.remove("fix"), n.classList.remove("ready");
              }, 105)),
          (window.lst = e));
      }),
      window.addEventListener("scroll", this.SCROLL_StickyHelper, {
        passive: !0,
      });
    let d = 0,
      o = document.querySelector(".sidebar__menus"),
      r = document.querySelector("#site-menu-sidebar button.close-sidebar"),
      i = document.querySelector("#site-menu-sidebar button.navigate-back");
    document
      .querySelectorAll(".sidebar__menus .sidebar__menu .has-submenu > a")
      .forEach((e) => {
        e.addEventListener("click", (e) => {
          e.preventDefault(),
            (o.scrollTop = 0),
            (d = e.target.parentElement.classList.contains("has-second-submenu")
              ? 2
              : 1),
            e.target.parentElement.classList.add("opened"),
            e.target.closest(".sidebar__menus").classList.add("opened"),
            e.target.parentElement.parentElement.classList.add("opened"),
            e.target.parentElement.parentElement.parentElement.classList.add(
              "opened"
            ),
            (r.style.display = "none"),
            (i.style.display = "flex");
        }),
          e.addEventListener("keydown", (s) => {
            if (s.keyCode == window.KEYCODES.RETURN) {
              t._unmountA11YHelper();
              let s = [i];
              e.parentElement.querySelectorAll("a").forEach((e) => {
                s.push(e);
              }),
                t._mountA11YHelper(s),
                setTimeout(() => {
                  i.focus();
                }, 10);
            }
          });
      }),
      document
        .querySelector(".sidebar__close button.navigate-back")
        .addEventListener("click", (e) => {
          e.preventDefault(),
            1 == d
              ? ((d = 0),
                o.classList.remove("opened"),
                o.querySelectorAll(".opened").forEach((e) => {
                  e.classList.remove("opened");
                }),
                (o.scrollTop = 0),
                (i.style.display = "none"),
                (r.style.display = "flex"))
              : 2 == d &&
                ((d = 1),
                o
                  .querySelector(".has-second-submenu.opened")
                  .parentElement.classList.remove("opened"),
                o
                  .querySelector(".has-second-submenu.opened")
                  .parentElement.parentElement.classList.remove("opened"),
                o
                  .querySelector(".has-second-submenu.opened")
                  .classList.remove("opened"));
        }),
      document
        .querySelector(".sidebar__close button.navigate-back")
        .addEventListener("keydown", (e) => {
          e.keyCode == window.KEYCODES.RETURN &&
            1 == d &&
            (t._unmountA11YHelper(),
            setTimeout(() => {
              r.focus(), t._mountA11YHelper();
            }, 10));
        });
  }
  unmount() {
    window.removeEventListener("resize", this.RESIZE_SidebarHelper),
      window.removeEventListener("scroll", this.SCROLL_StickyHelper);
  }
}
customElements.define("main-header", MainHeader);
class SidebarDrawer extends HTMLElement {
  constructor() {
    super(),
      this.querySelector(".close-sidebar").addEventListener("click", () => {
        this.hide();
      }),
      document.addEventListener("keydown", (e) => {
        if (e.keyCode == window.KEYCODES.ESC) {
          const e = document.querySelector("sidebar-drawer.sidebar--opened");
          e && e.hide();
        }
      });
  }
  show() {
    (this.opened = !0),
      document.body.classList.add("sidebar-opened"),
      this.classList.contains("sidebar--right")
        ? document.body.classList.add("sidebar-opened--right")
        : this.classList.contains("sidebar--left") &&
          document.body.classList.add("sidebar-opened--left"),
      (this.style.display = "block"),
      setTimeout(() => {
        this.classList.add("sidebar--opened"),
          (this.style.height = window.innerHeight + "px"),
          this._mountA11YHelper();
      }, 15);
  }
  hide() {
    (this.opened = !1),
      this.classList.remove("sidebar--opened"),
      document.body.classList.remove("sidebar-opened"),
      document.body.classList.remove("sidebar-opened--left"),
      document.body.classList.remove("sidebar-opened--right"),
      this._unmountA11YHelper(),
      "site-cart-sidebar" == this.id
        ? document
            .getElementById("cart-open-button")
            .setAttribute("aria-expanded", "false")
        : "site-search-sidebar" == this.id
        ? document
            .getElementById("search-open-button")
            .setAttribute("aria-expanded", "false")
        : "site-menu-sidebar" == this.id &&
          document
            .getElementById("menu-open-button")
            .setAttribute("aria-expanded", "false"),
      setTimeout(() => {
        this.style.display = "none";
      }, 501);
  }
  _mountA11YHelper(e) {
    let t =
        e ||
        this.querySelectorAll(
          '[tabindex="0"], button, [href], input:not([type="hidden"]), select, textarea, .regular-select-cover'
        ),
      s = t[0],
      n = t[t.length - 1];
    "site-cart-sidebar" == this.id &&
      "0" != this.querySelector(".cart-holder").getAttribute("data-items") &&
      (n = t[t.length - 2]),
      (this.A11Y_TAB_EVENT = ((e, t, s) => {
        ("Tab" === s.key || s.keyCode === window.KEYCODES.TAB) &&
          (s.shiftKey
            ? document.activeElement === e && (t.focus(), s.preventDefault())
            : document.activeElement === t && (e.focus(), s.preventDefault()));
      }).bind(this, s, n)),
      this.addEventListener("keydown", this.A11Y_TAB_EVENT);
  }
  _unmountA11YHelper() {
    this.removeEventListener("keydown", this.A11Y_TAB_EVENT);
  }
}
customElements.define("sidebar-drawer", SidebarDrawer);
class ProductModel extends HTMLElement {
  constructor() {
    super(),
      Shopify.loadFeatures([
        {
          name: "model-viewer-ui",
          version: "1.0",
          onLoad: this.setupModelViewerUI.bind(this),
        },
      ]);
  }
  setupModelViewerUI(e) {
    if (e) return;
    this.modelViewerUI = new Shopify.ModelViewerUI(
      this.querySelector("model-viewer")
    );
    const o = this.modelViewerUI.viewer;
    o.addEventListener("shopify_model_viewer_ui_toggle_play", () => {
      o.closest(".product-gallery") &&
        o.closest(".product-gallery").toggleDragging(!1);
    }),
      o.addEventListener("shopify_model_viewer_ui_toggle_pause", () => {
        o.closest(".product-gallery") &&
          o.closest(".product-gallery").toggleDragging(!0);
      }),
      o.closest(".product-gallery__item") &&
        "0" == o.closest(".product-gallery__item").dataset.index &&
        o.closest(".product-gallery") &&
        o.closest(".product-gallery").toggleDragging(!1);
  }
}
customElements.define("product-model", ProductModel),
  (window.ProductModel = {
    loadShopifyXR() {
      Shopify.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: this.setupShopifyXR.bind(this),
        },
      ]);
    },
    setupShopifyXR(e) {
      e ||
        (window.ShopifyXR
          ? (document.querySelectorAll('[id^="ProductJSON-"]').forEach((e) => {
              window.ShopifyXR.addModels(JSON.parse(e.textContent)), e.remove();
            }),
            window.ShopifyXR.setupXRElements())
          : document.addEventListener("shopify_xr_initialized", () =>
              this.setupShopifyXR()
            ));
    },
  });
class CollectionFiltersMobileHandle extends HTMLElement {
  constructor() {
    super(),
      this.querySelector("button").addEventListener("click", () => {
        document.getElementById("site-filters-sidebar").show();
      });
  }
}
customElements.define(
  "collection-filters-mobile-handle",
  CollectionFiltersMobileHandle
);
class ProductPage extends HTMLElement {
  constructor() {
    super(),
      (this.productGallery = this.querySelector(".product-gallery")),
      this.querySelector(".product__quantity") &&
        this.querySelector(".product__quantity").addEventListener(
          "click",
          (e) => {
            e.target.select();
          }
        );
    const e = this.querySelector("product-variants");
    if (
      (e &&
        (e.addEventListener(
          "VARIANT_CHANGE",
          this.onVariantChangeHandler.bind(this)
        ),
        this.onVariantChangeHandler({ target: e })),
      this.querySelector(".product__add-to-cart"))
    ) {
      const e = this.querySelector(".product__cart-actions-holder");
      new MutationObserver((t, s) => {
        for (const s of t)
          "class" == s.attributeName &&
            (e.classList.remove("disabled"),
            e.classList.remove("working"),
            s.target.classList.contains("disabled") &&
              e.classList.add("disabled"),
            s.target.classList.contains("working") &&
              e.classList.add("working"));
      }).observe(this.querySelector(".product__add-to-cart"), {
        attributes: !0,
        childList: !1,
        subtree: !1,
      }),
        this.querySelector(".product__add-to-cart").classList.contains(
          "disabled"
        ) && e.classList.add("disabled");
    }
    if (
      (this.productGallery.addEventListener("change", (e) => {
        "model" ==
          this.productGallery.items[this.productGallery.index].dataset
            .productMediaType &&
          (setTimeout(() => {
            this.productGallery.toggleDragging(!1);
          }, 15),
          this.xrButton &&
            this.xrButton.setAttribute(
              "data-shopify-model3d-id",
              this.productGallery.items[this.productGallery.index].dataset
                .mediaId
            )),
          pauseAllMedia();
      }),
      !this.classList.contains("featured-product"))
    ) {
      const e = this.querySelector(".product__offers > div");
      (this._EVENT_SCROLL = (t) => {
        if (window.innerHeight < e.offsetHeight) {
          let t = this.getBoundingClientRect().y,
            s = e.offsetHeight - window.innerHeight;
          Math.abs(t) < s
            ? (e.style.top = t + "px")
            : Math.abs(t) >= s && (e.style.top = -s + "px");
        }
      }),
        window.addEventListener("scroll", this._EVENT_SCROLL, { passive: !0 }),
        (this.style.minHeight = e.offsetHeight + "px"),
        setInterval(() => {
          this.style.minHeight = e.offsetHeight + "px";
        }, 500);
    }
    if (
      !document.body.classList.contains("template-cart") &&
      "overlay" == KROWN.settings.cart_action
    ) {
      let e = !1;
      this.querySelector(".product__add-to-cart") &&
        this.querySelector(".product__add-to-cart").addEventListener(
          "keyup",
          (t) => {
            t.keyCode == window.KEYCODES.RETURN && (e = !0);
          }
        ),
        this.querySelector(".product__form") &&
          this.querySelector(".product__form").addEventListener(
            "add-to-cart",
            () => {
              window.preloadImages(
                document.getElementById("site-cart-sidebar")
              ),
                document.getElementById("site-cart-sidebar").show(),
                e &&
                  setTimeout(() => {
                    document
                      .querySelector("#site-cart-sidebar .close-sidebar")
                      .focus();
                  }, 200);
            }
          );
    }
    this.querySelectorAll("product-model") &&
      (window.ProductModel.loadShopifyXR(),
      (this.xrButton = this.querySelector(".product-gallery__view-in-space")));
  }
  onVariantChangeHandler(e) {
    let t = e.target.currentVariant;
    if (t && null != t.featured_media) {
      let e = this.productGallery.querySelector(
        '.product-gallery__item[data-media-id="' + t.featured_media.id + '"]'
      );
      e &&
        (this.productGallery.classList.contains("js-enabled")
          ? this.productGallery.changeSlide(parseInt(e.dataset.index))
          : (this.productGallery.dataset.initialIndex = e.dataset.index));
    }
  }
}
customElements.define("product-page", ProductPage);
class ProductSlider extends HTMLElement {
  constructor() {
    super();
    const e = navigator.userAgent.toLowerCase();
    (this._ios15 =
      ("ontouchstart" in window ||
        (window.DocumentTouch && document instanceof DocumentTouch)) &&
      e.includes("applewebkit") &&
      (e.includes("os 15_") || e.includes("version/15"))),
      this.classList.add("js-enabled"),
      (this.viewport = this.querySelector(".product-gallery__viewport")),
      (this.container = this.querySelector(".product-gallery__container")),
      (this.holder = this.querySelector(".product-gallery__items")),
      (this.items = this.querySelectorAll(".product-gallery__item")),
      (this.index = this.dataset.initialIndex
        ? parseInt(this.dataset.initialIndex)
        : 0),
      (this.length = this.items.length),
      (this.timeout = null),
      (this.animating = !1),
      (this._mobilePadding = parseInt(
        window
          .getComputedStyle(document.documentElement)
          .getPropertyValue("--grid-padding")
      )),
      (this.changeSlide = (e) => {
        if (this.mobile)
          this._iOS15snapping(),
            this.holder.scrollTo({
              left:
                this.items[e].offsetLeft -
                parseInt(getComputedStyle(this.items[e]).marginLeft),
              top: 0,
              behavior: "smooth",
            }),
            this._checkNav(e),
            this._checkIndex(!0),
            this._setHeight();
        else if (
          (this._blockAnimation(!0), this._resetClasses(), e > this.index)
        ) {
          let t = this.index;
          (this.index = e - 1),
            this.holder.classList.add("no-transitions"),
            this._resetClasses(),
            this._resetOrder([t, this.index]),
            (this.holder.style.transform = `translateX(${
              this.index * this.width * -1
            }px`),
            this.items[t].classList.add("active"),
            this.items[e].classList.add("after-active"),
            this._checkNav(e),
            setTimeout(() => {
              this.holder.classList.remove("no-transitions"),
                this.items[t].classList.remove("active"),
                this.items[t].classList.add("before-active"),
                (this.holder.style.transform = `translateX(${
                  e * this.width * -1
                }px`),
                this.items[e].classList.remove("after-active"),
                this.items[e].classList.add("active"),
                (this.index = e),
                this.dispatchEvent(this.EVENT_CHANGE);
            }, 10);
        } else if (e < this.index) {
          let t = this.index;
          (this.index = e + 1),
            this.holder.classList.add("no-transitions"),
            this._resetClasses(),
            this._resetOrder([t, this.index]),
            (this.holder.style.transform = `translateX(${
              this.index * this.width * -1
            }px`),
            this.items[t].classList.add("active"),
            this.items[e].classList.add("before-active"),
            this._checkNav(e),
            setTimeout(() => {
              this.holder.classList.remove("no-transitions"),
                this.items[t].classList.remove("active"),
                this.items[t].classList.add("after-active"),
                (this.holder.style.transform = `translateX(${
                  e * this.width * -1
                }px`),
                this.items[e].classList.remove("before-active"),
                this.items[e].classList.add("active"),
                (this.index = e),
                this.dispatchEvent(this.EVENT_CHANGE);
            }, 10);
        }
        this._setHeight(e);
      }),
      (this.toggleDragging = (e) => {
        e
          ? this.container.classList.remove("force-no-drag")
          : this.container.classList.add("force-no-drag");
      }),
      (this.EVENT_CHANGE = new Event("change")),
      (this.EVENT_SETTLE = new Event("settle"));
    const t = document.createElement("div");
    t.setAttribute(
      "class",
      "product-gallery__navigation five-tenths lap--six-tenths smaller-lap--eleven-tenths push-left-one-tenth lap--push-left-none smaller-lap--push-left-padding"
    ),
      (t.innerHTML = `\n\t\t\t<div class="product-gallery__no">\n\t\t\t\t<span class="product-gallery__index">${
        this.index + 1
      }</span> / ${
        this.length
      }\n\t\t\t</div>\n\t\t\t<button class="product-gallery__prev simple-arrow simple-arrow--left">\n\t\t\t\t<span class="visually-hidden">${
        KROWN.settings.locales.prev
      }</span>\n\t\t\t\t${
        KROWN.settings.symbols.arrow
      }\n\t\t\t</button>\n\t\t\t<button class="product-gallery__next simple-arrow simple-arrow--right">\n\t\t\t\t<span class="visually-hidden">${
        KROWN.settings.locales.next
      }</span>\n\t\t\t\t${KROWN.settings.symbols.arrow}\n\t\t\t</button>`),
      this.appendChild(t),
      (this.indexEl = this.querySelector(".product-gallery__index")),
      (this.prevEl = this.querySelector(".product-gallery__prev")),
      (this.nextEl = this.querySelector(".product-gallery__next")),
      this.prevEl.addEventListener("click", () => {
        this.prevSlide(), playMedia(this.items[this.index]);
      }),
      this.nextEl.addEventListener("click", () => {
        this.nextSlide(), playMedia(this.items[this.index]);
      }),
      this.querySelectorAll(
        ".product-gallery__prev, .product-gallery__next"
      ).forEach((e) => {
        e.addEventListener("keydown", (e) => {
          e.keyCode == window.KEYCODES.RETURN &&
            ((window.scrollY = this.container.offsetTop - 100),
            setTimeout(() => {
              this.items[this.index].focus();
            }, 50));
        });
      }),
      this.container.addEventListener(
        "touchstart",
        (e) => {
          this.mobile ||
            this.container.classList.contains("force-no-drag") ||
            ((this.touchX = e.touches[0].screenX),
            this.container.classList.add("dragging-enabled"));
        },
        { passive: !0 }
      ),
      this.container.addEventListener(
        "touchmove",
        (e) => {
          if (
            !this.mobile &&
            this.container.classList.contains("dragging-enabled") &&
            !this.container.classList.contains("force-no-drag")
          ) {
            let t = this.touchX - e.touches[0].screenX;
            t > 0
              ? (this.nextSlide(),
                this.container.classList.remove("dragging-enabled"))
              : t < 0 &&
                (this.prevSlide(),
                this.container.classList.remove("dragging-enabled"));
          }
        },
        { passive: !0 }
      ),
      this.container.addEventListener(
        "touchend",
        (e) => {
          this.mobile || this.container.classList.remove("dragging-enabled");
        },
        { passive: !0 }
      ),
      this.container.addEventListener("mousedown", (e) => {
        this.mobile ||
          this.container.classList.contains("force-no-drag") ||
          ((this.mouseX = e.screenX),
          this.container.classList.add("dragging-enabled"),
          this.container.classList.add("mouse-down"));
      }),
      this.container.addEventListener("mouseup", (e) => {
        this.mobile ||
          (this.container.classList.remove("mouse-down"),
          this.container.classList.remove("pointer-events-off"),
          this.container.classList.remove("dragging-enabled"));
      }),
      this.container.addEventListener("mousemove", (e) => {
        if (
          !this.mobile &&
          this.container.classList.contains("dragging-enabled") &&
          !this.container.classList.contains("force-no-drag")
        ) {
          let t = this.mouseX - e.screenX;
          Math.abs(t) > 1 &&
            (this.container.classList.add("pointer-events-off"),
            t > 0
              ? (this.nextSlide(),
                this.container.classList.remove("dragging-enabled"))
              : t < 0 &&
                (this.prevSlide(),
                this.container.classList.remove("dragging-enabled")));
        }
      }),
      (this.OBSERVER = new IntersectionObserver(
        (e) => {
          this.mobile &&
            e.forEach((e) => {
              e.intersectionRatio >= 0.3 &&
                ((this.index = parseInt(e.target.getAttribute("data-index"))),
                this._checkNav(),
                this._checkIndex(!0),
                this._setHeight(),
                this.dispatchEvent(this.EVENT_CHANGE));
            });
        },
        { threshold: [0, 0.3] }
      )),
      this.items.forEach((e) => {
        this.OBSERVER.observe(e);
      }),
      this._checkMobile(),
      this._resetOrder(),
      this._checkIndex(),
      this._checkNav(),
      this._setHeight(),
      this._getSliderWidth(),
      setTimeout(() => {
        this._getSliderWidth(), this._repositionSlider();
      }, 100),
      this._repositionSlider(),
      (this.EVENT_RESIZE = () => {
        this._checkMobile(),
          this._setHeight(),
          this._getSliderWidth(),
          this._repositionSlider(),
          (this._mobilePadding = parseInt(
            window
              .getComputedStyle(document.documentElement)
              .getPropertyValue("--grid-padding")
          ));
      }),
      window.addEventListener("resize", this.EVENT_RESIZE),
      this.items[this.index].classList.add("enable-tab"),
      this.mobile &&
        (this.holder.scrollLeft = this.items[this.index].offsetLeft);
  }
  _checkMobile() {
    -1 != getComputedStyle(this, ":after").content.indexOf("mobile-enabled")
      ? (this.mobile = !0)
      : (this.mobile = !1);
  }
  _checkIndex(e = !1) {
    e && this._resetClasses(),
      this.items[this.index].classList.add("active"),
      this.items[this.index + 1] &&
        this.items[this.index + 1].classList.add("after-active"),
      this.items[this.index - 1] &&
        this.items[this.index - 1].classList.add("before-active"),
      e || (this.indexEl.innerHTML = this.index + 1);
  }
  _checkNav(e = null) {
    let t = null != e ? e : this.index;
    this.nextEl.classList.remove("active"),
      this.nextEl.classList.remove("disabled"),
      this.prevEl.classList.remove("disabled"),
      this.nextEl.removeAttribute("disabled"),
      this.prevEl.removeAttribute("disabled"),
      this.items[t + 1] ||
        (this.nextEl.classList.add("disabled"),
        this.nextEl.setAttribute("disabled", "disabled")),
      this.items[t - 1] ||
        (this.prevEl.classList.add("disabled"),
        this.prevEl.setAttribute("disabled", "disabled")),
      (this.indexEl.innerHTML = t + 1);
  }
  _getSliderWidth() {
    this.width = this.items[0].getBoundingClientRect().width;
  }
  _repositionSlider() {
    this.holder.classList.add("no-transitions"),
      (this.holder.style.transform = `translateX(${
        this.index * this.width * -1
      }px`),
      setTimeout(() => {
        this.holder.classList.remove("no-transitions");
      }, 10);
  }
  _resetClasses() {
    this.items.forEach((e) => {
      e.classList.remove("before-active"),
        e.classList.remove("after-active"),
        e.classList.remove("active");
    });
  }
  _resetOrder(e = null) {
    this.items.forEach((t, s) => {
      let i = s;
      null != e && (s == e[0] ? (i = e[1]) : s == e[1] && (i = e[0])),
        (t.style.order = i);
    });
  }
  _translateSlider() {
    (this.holder.style.transform = `translateX(${
      this.index * this.width * -1
    }px`),
      this._checkIndex(),
      this._checkNav();
  }
  _blockAnimation(e = !1) {
    (this.animating = !0),
      (this.timeout = setTimeout(() => {
        (this.animating = !1),
          this.dispatchEvent(this.EVENT_SETTLE),
          e && (this._resetOrder(), this._resetClasses(), this._checkIndex());
      }, 500));
  }
  _setHeight(e = null, t = !0) {
    let s = null != e ? e : this.index;
    t || this.viewport.classList.add("no-transition"),
      this.items[s].querySelector(".lazy-image") &&
        (this.viewport.style.height =
          this.items[s].querySelector(".lazy-image").offsetHeight + "px"),
      t ||
        setTimeout(() => {
          this.viewport.classList.remove("no-transition");
        }, 20);
  }
  _iOS15snapping() {
    this._ios15 && this.holder.classList.add("disable-snapping"),
      setTimeout(() => {
        this._ios15 && this.holder.classList.remove("disable-snapping");
      }, 500);
  }
  nextSlide() {
    this.mobile
      ? (this.index + 1 < this.length && this.index++,
        this._iOS15snapping(),
        this.holder.scrollTo({
          left:
            this.items[this.index].offsetLeft -
            parseInt(getComputedStyle(this.items[this.index]).marginLeft),
          top: 0,
          behavior: "smooth",
        }),
        this._setHeight(),
        this._checkNav(),
        this._checkIndex(!0))
      : this.animating ||
        (this._blockAnimation(),
        this._resetClasses(),
        this.index + 1 < this.length && this.index++,
        this._checkIndex(),
        this._checkNav(),
        this._setHeight(),
        this._translateSlider(),
        this.dispatchEvent(this.EVENT_CHANGE));
  }
  prevSlide() {
    this.mobile
      ? (this.index - 1 >= 0 && this.index--,
        this._iOS15snapping(),
        this.holder.scrollTo({
          left:
            this.items[this.index].offsetLeft -
            parseInt(getComputedStyle(this.items[this.index]).marginLeft),
          top: 0,
          behavior: "smooth",
        }),
        this._setHeight(),
        this._checkNav(),
        this._checkIndex(!0))
      : this.animating ||
        (this._blockAnimation(),
        this._resetClasses(),
        this.index - 1 >= 0 && this.index--,
        this._checkIndex(),
        this._checkNav(),
        this._setHeight(),
        this._translateSlider(),
        this.dispatchEvent(this.EVENT_CHANGE));
  }
}
customElements.define("product-slider", ProductSlider);
class ProductReviews {
  constructor(e) {
    const t = new MutationObserver((e, t) => {
      for (const s of e)
        s.addedNodes.length > 0 &&
          s.addedNodes.forEach((e) => {
            "DIV" == e.tagName &&
              e.classList.contains("spr-container") &&
              (this.init(e), t.disconnect());
          });
    });
    e.querySelector(".spr-review")
      ? this.init(e.querySelector(".spr-container"))
      : t.observe(e, { childList: !0 });
  }
  init(e) {
    if (e.querySelector(".spr-review")) {
      const t = document.querySelector(".product__price-reviews .rating-text");
      document
        .querySelector("#shopify-product-reviews .spr-summary-starrating")
        .prepend(
          this.createRatingEl(
            document.querySelector(".spr-summary-starrating"),
            "spr-custom-rating",
            t ? t.textContent : ""
          )
        );
      const s = e.querySelector(".spr-reviews");
      s.querySelectorAll(".spr-review").forEach((e, t) => {
        (e.classList = `spr-review css-slide three-tenths lap--smart-width palm--smart-width ${
          0 == t ? "push-left-one-tenth" : "push-left-half-tenth"
        } palm--push-left-padding`),
          (e.dataset.index = 99);
      });
      const i = document.createElement("div");
      (i.innerHTML = `<css-slider\n\t      class="css-slider css-slider--snapping" \n\t      data-navigation-class="ten-tenths lap--twelve-tenths push-left-one-tenth lap--push-left-padding"\n\t     >\n\t    \t<div class="spr-reviews css-slides-container">\n\t      \t${s.innerHTML}\n\t      </div>\n      </div>`),
        i.querySelectorAll(".spr-review").forEach((e) => {
          this.initReview(e);
        }),
        s.remove(),
        e.querySelector(".spr-content").append(i),
        e.querySelector(".spr-summary-actions").classList.add("with-reviews"),
        e.append(e.querySelector(".spr-summary-actions"));
      const r = i.querySelector("css-slider");
      setTimeout(() => {
        r.resetSlider(!0);
      }, 100);
      const n = new IntersectionObserver(
        (e, t) => {
          e.forEach((e) => {
            if (
              e.isIntersecting &&
              e.target.querySelector(".spr-pagination-next a")
            ) {
              const t = e.target.querySelector(".spr-pagination-next a");
              getJSONP(
                `${SPR.api_url}/reviews?page=${t.dataset.page}&product_id=${t.dataset.productId}&shop=${window.location.hostname}&callback=?`,
                (e) => {
                  t.closest(".spr-pagination").remove();
                  const s = new DOMParser().parseFromString(
                    e.reviews,
                    "text/html"
                  );
                  s.querySelectorAll(".spr-review, .spr-pagination") &&
                    s
                      .querySelectorAll(".spr-review, .spr-pagination")
                      .forEach((e) => {
                        e.classList.contains("spr-review") &&
                          ((e.classList =
                            "spr-review css-slide three-tenths lap--smart-width palm--smart-width push-left-half-tenth palm--push-left-padding"),
                          (e.dataset.index = 99)),
                          r.querySelector(".css-slides-container").append(e),
                          e.classList.contains("spr-pagination")
                            ? (n.disconnect(), n.observe(e))
                            : this.initReview(e);
                      }),
                    r.afterAppend(),
                    r.resetSlider(!0, !1);
                }
              );
            }
          });
        },
        { threshold: 1 }
      );
      i.querySelector(".spr-pagination") &&
        n.observe(i.querySelector(".spr-pagination"));
    }
    const t = document.createElement("div");
    (t.id = "spr-form-modal"),
      (t.innerHTML =
        '<div id="spr-form" class="spr-form-holder address-popup">\n      <div class="basicLightboxClose" tabindex="0">×</div>\n    </div>'),
      document
        .querySelector(".spr-summary-actions-newreview")
        .setAttribute("onclick", "");
    const s = basicLightbox.create(t, {
      trigger: document.querySelector(".spr-summary-actions-newreview"),
      focus: 'input[type="text"]',
    });
    s
      .element()
      .querySelector(".spr-form-holder")
      .prepend(e.querySelector(".spr-form")),
      (s.element().querySelector(".spr-form").style.display = "block"),
      (e.querySelector(".spr-summary-actions-newreview").innerHTML = `\n    \t${
        KROWN.settings.symbols.plus
      }\n    \t<span>${
        e.querySelector(".spr-summary-actions-newreview").innerHTML
      }</span>`);
  }
  initReview(e) {
    e
      .querySelector(".spr-review-header")
      .insertBefore(
        this.createRatingEl(e, "spr-review-custom-rating"),
        e.querySelector(".spr-review-header").firstElementChild.nextSibling
      ),
      e.insertBefore(
        e.querySelector(".spr-review-header-byline"),
        e.querySelector(".spr-review-footer")
      );
    let t = e.querySelector(".spr-review-content-body").textContent;
    if (wordFunctions.count(t) > 30) {
      const s = document.createElement("span");
      (s.classList = "spr-review-read-more"),
        (s.textContent = KROWN.settings.locales.product_read_review),
        (s.tabIndex = 0);
      basicLightbox.create(
        `<div class="spr-review-modal">\n\t    \t<div class="spr-review-header">${
          e.querySelector(".spr-review-header").innerHTML
        }</div>\n\t    \t${
          e.querySelector(".spr-review-content-body").innerHTML
        }\n\t    \t<span class="spr-review-header-byline">${
          e.querySelector(".spr-review-header-byline").innerHTML
        }</span>\n\t    </div>`,
        { trigger: s }
      );
      (e.querySelector(".spr-review-content-body").textContent =
        wordFunctions.trim(t, 30)),
        e.querySelector(".spr-review-content").append(s);
    }
    e.querySelector(".spr-review-reportreview").setAttribute("tabindex", "-1");
  }
  createRatingEl(e, t, s = "") {
    const i = e.querySelectorAll(".spr-icon-star").length,
      r = e.querySelectorAll(".spr-icon-star-half-alt").length > 0 ? ".5" : "",
      n = document.createElement("span");
    return (
      (n.classList = t + " text-size--regular"),
      (n.innerHTML = `<span>${"" != s ? s : i + r + " / 5"}</span>${
        KROWN.settings.symbols.star
      }`),
      n
    );
  }
}
document.getElementById("shopify-product-reviews") &&
  new ProductReviews(document.getElementById("shopify-product-reviews"));
const wordFunctions = {
  count: function (e) {
    return e.match(/(\w+)/g).length;
  },
  trim: function (e, t) {
    const s = e.trim().split(" "),
      i = s.length > t ? "..." : "";
    return s.slice(0, t).join(" ") + i;
  },
};
class CollectionListItem extends HTMLElement {
  constructor() {
    super(),
      setTimeout(() => {
        this.querySelector(".collection-list-item-image").style.visibility =
          "visible";
      }, 200),
      this.addEventListener(
        "mousemove",
        (e) => {
          const t = this.querySelector(".collection-list-item-image");
          (t.style.top = e.clientY - this.getBoundingClientRect().top + "px"),
            (t.style.left =
              e.clientX - this.getBoundingClientRect().left + "px");
        },
        { passive: !0 }
      );
  }
}
customElements.define("collection-list-item", CollectionListItem);
class SliderVertical extends HTMLElement {
  constructor() {
    super(), this.UNMOUNT(), this.MOUNT();
  }
  MOUNT() {
    this.querySelectorAll("video").forEach((e) => {
      isAutoplaySupported((t) => {
        if (t) e.classList.add("loaded"), e.play();
        else {
          const t = e.closest(".slide-image");
          e.parentNode.remove(), window.preloadImages(t);
        }
      });
    }),
      (this.headingsHolder = this.querySelector(".vertical-slider-headings")),
      this.querySelectorAll(".slide-heading").forEach((e) => {
        const t = e.cloneNode(!0);
        this.headingsHolder.appendChild(t);
      }),
      (this.headings = this.querySelectorAll(
        ".vertical-slider-headings .slide-heading"
      )),
      (this.OBSERVER_A = new IntersectionObserver(
        (e) => {
          e.forEach((e) => {
            this._observer_A_function(e);
          });
        },
        { threshold: [0.05, 0.6] }
      )),
      (this.OBSERVER_B = new IntersectionObserver(
        (e) => {
          e.forEach((e) => {
            this._observer_B_function(e);
          });
        },
        { threshold: [0.05, 0.7] }
      )),
      (this.OBSERVER_MAIN = new IntersectionObserver(
        (e) => {
          e.forEach((e) => {
            this._observer_MAIN_function(e);
          });
        },
        { threshold: 0 }
      )),
      (this.OBSERVER_NEXT = new IntersectionObserver(
        (e) => {
          e.forEach((e) => {
            this._observer_NEXT_function(e);
          });
        },
        { threshold: 0 }
      )),
      (this.slides = this.querySelectorAll(".slide")),
      this.slides.forEach((e) => {
        if (
          ("true" === e.dataset.first
            ? (this.OBSERVER_A.observe(e),
              "true" === e.dataset.last && this.OBSERVER_B.observe(e))
            : this.OBSERVER_B.observe(e),
          e.hasAttribute("data-link"))
        ) {
          const t = document.createElement("a");
          (t.className = "slide-heading"),
            t.setAttribute("href", e.querySelector("a").getAttribute("href")),
            e.querySelector(".slide-title") &&
              t.appendChild(e.querySelector(".slide-title")),
            e.querySelector(".slide-caption") &&
              t.appendChild(e.querySelector(".slide-caption")),
            e.querySelector(".slide-heading").append(t);
        }
      }),
      this.OBSERVER_MAIN.observe(this.parentNode),
      setTimeout(() => {
        if (this.parentNode.nextElementSibling)
          this.OBSERVER_NEXT.observe(this.parentNode.nextElementSibling);
        else {
          const e = document.querySelector(".page-content").nextElementSibling;
          0 == e.children.length && (e = e.nextElementSibling),
            this.OBSERVER_NEXT.observe(e);
        }
        if (!this.parentNode.previousSibling) {
          const e = this.querySelectorAll(
            ".vertical-slider-headings .slide-heading"
          )[0];
          e.classList.add("never-remove"),
            Math.abs(this.parentNode.getBoundingClientRect().y) <
              window.innerHeight &&
              (e.classList.add("active-up"), (e.style.display = "flex"));
        }
      }, 25),
      (this.RESIZE_EVENT = debounce(() => {
        this._resizeCaptions();
      }, 100)),
      window.addEventListener("resize", this.RESIZE_EVENT),
      this._resizeCaptions();
  }
  _observer_A_function(e) {
    const t = this.headings[e.target.dataset.index];
    "true" === e.target.dataset.first &&
      (!e.target.classList.contains("active") && e.intersectionRatio >= 0.6
        ? (this.querySelector(".slide.active") &&
            this.querySelector(".slide.active").classList.remove("active"),
          e.target.classList.add("active"),
          this._resetHeadingClasses(),
          (t.style.display = "flex"),
          e.boundingClientRect.top > 0
            ? t.classList.add("active-up")
            : t.classList.add("active-down"))
        : !e.target.classList.contains("active") &&
          e.intersectionRatio >= 0.05 &&
          e.intersectionRatio < 0.6
        ? (this.querySelector(".slide.active") &&
            this.querySelector(".slide.active").classList.remove("active"),
          e.target.classList.add("active"),
          this._resetHeadingClasses(),
          (t.style.display = "flex"),
          t.classList.add("active-down"))
        : !t.classList.contains("never-remove") &&
          e.target.classList.contains("active") &&
          e.intersectionRatio < 0.6 &&
          e.boundingClientRect.top > 0 &&
          (e.target.classList.remove("active"),
          t.classList.remove("active-up"),
          t.classList.remove("active-down"),
          t.classList.add("hide-up")));
  }
  _observer_B_function(e) {
    const t = this.headings[e.target.dataset.index];
    e.intersectionRatio > 0.05 &&
      !e.target.classList.contains("active") &&
      "true" !== e.target.dataset.first &&
      (("true" === e.target.dataset.last && e.boundingClientRect.top < 0) ||
        (this.querySelector(".slide.active") &&
          this.querySelector(".slide.active").classList.remove("active"),
        e.target.classList.add("active"),
        this._resetHeadingClasses(),
        (t.style.display = "flex"),
        e.boundingClientRect.top > 0
          ? t.classList.add("active-up")
          : t.classList.add("active-down")));
  }
  _observer_MAIN_function(e) {
    0 == e.intersectionRatio &&
      (this.querySelector(".slide.active") &&
        this.querySelector(".slide.active").classList.remove("active"),
      this.querySelectorAll(".active-up").forEach((e) => {
        e.classList.remove("active-up");
      }),
      this.querySelectorAll(".active-down").forEach((e) => {
        e.classList.remove("active-down");
      }),
      this.querySelectorAll(".slide-heading").forEach((e) => {
        e.style.display = "none";
      }));
  }
  _observer_NEXT_function(e) {
    if (e.intersectionRatio > 0)
      this.slides[this.slides.length - 1].classList.contains("active") &&
        setTimeout(() => {
          this.querySelector(".slide.active") &&
            this.querySelector(".slide.active").classList.remove("active"),
            this.querySelectorAll(".active-up").forEach((e) => {
              e.classList.remove("active-up");
            }),
            this.querySelectorAll(".active-down").forEach((e) => {
              e.classList.remove("active-down");
            }),
            this.headings[this.headings.length - 1].classList.add("hide-down");
        }, 20);
    else if (
      0 == e.intersectionRatio &&
      e.boundingClientRect.top > 0 &&
      !this.querySelector(".slide.active")
    ) {
      let e = this.parentNode.getBoundingClientRect();
      if (e.y < 0 && Math.abs(e.y) < e.height) {
        this.slides[this.slides.length - 1].classList.add("active");
        let e = this.headings[this.headings.length - 1];
        e.classList.remove("hide-down"),
          e.classList.remove("hide-up"),
          (e.style.display = "flex"),
          e.classList.add("active-up");
      }
    }
  }
  _resetHeadingClasses() {
    this.headingsHolder
      .querySelectorAll(".active-up, .active-down, .hide-down, .hide-up")
      .forEach((e) => {
        (e.style.display = "none"),
          e.classList.remove("active-up"),
          e.classList.remove("active-down"),
          e.classList.remove("hide-down"),
          e.classList.remove("hide-up");
      });
  }
  _resizeCaptions() {
    this.slides.forEach((e) => {
      e.querySelectorAll(".slide-image[data-caption]").forEach(function (e) {
        e.querySelector(".slide-image__caption").style.width =
          e.offsetHeight - 10 + "px";
      });
    });
  }
  initVideo(e) {
    e.classList.add("loaded");
  }
  UNMOUNT() {
    this.OBSERVER_A && this.OBSERVER_A.disconnect(),
      this.OBSERVER_B && this.OBSERVER_B.disconnect(),
      this.OBSERVER_MAIN && this.OBSERVER_MAIN.disconnect(),
      this.OBSERVER_NEXT && this.OBSERVER_NEXT.disconnect(),
      window.removeEventListener("resize", this.RESIZE_EVENT);
  }
}
customElements.define("vertical-slider", SliderVertical),
  Object.defineProperty(HTMLMediaElement.prototype, "playing", {
    get: function () {
      return !!(
        this.currentTime > 0 &&
        !this.paused &&
        !this.ended &&
        this.readyState > 2
      );
    },
  });
(KROWN.themeName = "Highlight"), (KROWN.themeVersion = "2.2.3");
const executeOnceOnDomContentLoaded = () => {
  reframe(
    document.querySelectorAll(
      '.rte iframe[src*="youtube"], .rte iframe[src*="vimeo"]'
    )
  ),
    document
      .querySelectorAll(
        ".css-slider, .product-variant__input, .simple-arrow, .mount-header [tabindex]"
      )
      .forEach((e) => {
        e.addEventListener("blur", (e) => {
          e.currentTarget.classList.remove("focus");
        });
      });
  let e = document.activeElement;
  document.addEventListener("keyup", (t) => {
    t.keyCode == window.KEYCODES.TAB &&
      (e.classList.contains("focus") &&
        t.target != e &&
        e.classList.remove("focus"),
      (t.target.classList.contains("css-slider") ||
        t.target.classList.contains("product-variant__input") ||
        t.target.classList.contains("simple-arrow") ||
        "-1" != t.target.getAttribute("tabindex")) &&
        t.target.classList.add("focus"),
      (e = document.activeElement));
  }),
    "?customer_posted=true" == window.location.search
      ? setTimeout(() => {
          window.scroll({
            top: document.querySelector("form .alert").offsetTop - 250,
            behavior: "smooth",
          });
        }, 300)
      : window.location.pathname.includes("/challenge") &&
        setTimeout(() => {
          window.scroll({ top: 0, behavior: "auto" });
        }, 300),
    document.querySelectorAll(".rte a img").forEach((e) => {
      e.parentNode.style.border = "none";
    });
};
"loading" !== document.readyState
  ? executeOnceOnDomContentLoaded()
  : document.addEventListener(
      "DOMContentLoaded",
      executeOnceOnDomContentLoaded
    ),
  window.refreshCart ||
    (window.refreshCart = () => {
      fetch("?section_id=cart-helper")
        .then((e) => e.text())
        .then((e) => {
          const t = new DOMParser().parseFromString(e, "text/html"),
            o = t.getElementById("AjaxCartForm").innerHTML,
            n = t.getElementById("AjaxCartSubtotal").innerHTML,
            r = document.getElementById("AjaxCartForm");
          (r.innerHTML = o),
            r.ajaxifyCartItems(),
            (document.querySelector("[data-header-cart-count]").textContent =
              r.querySelector("[data-cart-count]").textContent),
            (document.getElementById("AjaxCartSubtotal").innerHTML = n),
            window.preloadImages(r),
            document.getElementById("site-cart-sidebar").show();
        });
    });
